var $t = Object.defineProperty;
var Nt = (n, a, t) => a in n ? $t(n, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[a] = t;
var X = (n, a, t) => Nt(n, typeof a != "symbol" ? a + "" : a, t);
import { z as e } from "zod";
class x extends Error {
  constructor(t, r, i, o) {
    super(t);
    X(this, "status");
    X(this, "code");
    X(this, "body");
    this.name = "ApiError", this.status = r, this.code = o, this.body = i;
  }
  /** True для 401 (требуется re-login). */
  get isUnauthorized() {
    return this.status === 401;
  }
  /** True для 403 (отсутствует permission). */
  get isForbidden() {
    return this.status === 403;
  }
  /** True для 404. */
  get isNotFound() {
    return this.status === 404;
  }
  /** True для 5xx — должен ретрайаться UI'ом. */
  get isServerError() {
    return this.status >= 500;
  }
}
function xt(n, a, t) {
  const r = a.startsWith("http://") || a.startsWith("https://"), i = n.startsWith("http://") || n.startsWith("https://"), o = typeof window < "u" && window.location ? window.location.origin : "http://localhost", s = r ? new URL(a) : i ? new URL(`${n}${a}`) : new URL(`${n}${a}`, o);
  if (t) {
    for (const [l, c] of Object.entries(t))
      if (c != null)
        if (Array.isArray(c))
          for (const d of c)
            d != null && s.searchParams.append(l, String(d));
        else
          s.searchParams.set(l, String(c));
  }
  return s.toString();
}
function mi(n) {
  const { baseUrl: a } = n;
  if (!(a.startsWith("http://") || a.startsWith("https://") || a.startsWith("/")))
    throw new Error(
      `Некорректный baseUrl ApiClient'а: "${a}". Ожидается абсолютный URL (http(s)://...) либо относительный путь от origin'а (/api).`
    );
  const r = n.fetch ?? globalThis.fetch.bind(globalThis);
  async function i(o, s = {}) {
    const { method: l = "GET", token: c, body: d, query: j, headers: G, ...Q } = s, J = xt(n.baseUrl, o, j), g = {
      Accept: "application/json",
      ...n.defaultHeaders,
      ...G
    };
    c && (g.Authorization = `Bearer ${c}`), d !== void 0 && !(d instanceof FormData) && (g["Content-Type"] = g["Content-Type"] ?? "application/json");
    const E = await r(J, {
      ...Q,
      method: l,
      headers: g,
      body: d === void 0 ? void 0 : d instanceof FormData ? d : JSON.stringify(d)
    });
    if (E.status === 204) return;
    const _e = E.headers.get("content-type") ?? "", de = _e.includes("application/json") || _e.includes("+json"), f = de ? await E.json().catch(() => null) : await E.text();
    if (!E.ok) {
      const qt = de && f && typeof f == "object" && "code" in f ? String(f.code) : void 0, Dt = de && f && typeof f == "object" && "message" in f ? String(f.message) : `HTTP ${E.status}`;
      throw new x(Dt, E.status, f, qt);
    }
    return f;
  }
  return {
    request: i,
    config: n
  };
}
const Fe = e.enum(["light", "dark", "auto"]), We = e.object({
  userId: e.string(),
  username: e.string(),
  email: e.string().email().optional().nullable(),
  displayName: e.string().optional().nullable(),
  distributorId: e.number().int().nullable().optional(),
  /** Subdomain slug текущего тенанта (например, "darkside"). Используется
   *  для построения URL обмена с 1С: `https://<slug>.ds2b.ru/seller/exchange-1c`.
   *  null для PLATFORM_ADMIN. (S21 / D14-Arch-3) */
  distributorSubdomainSlug: e.string().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  isPlatformAdmin: e.boolean(),
  permissions: e.array(e.string()),
  roles: e.array(e.string()),
  themePreference: Fe.default("auto"),
  /** Для CLIENT_EMPLOYEE — id точек, на которые он назначен. (D01 §1.4) */
  assignedTradepointIds: e.array(e.number().int()).optional().nullable()
}), kt = e.object({
  themePreference: Fe.optional(),
  displayName: e.string().min(1).max(120).optional()
}).strict(), Ye = e.object({
  userId: e.string(),
  username: e.string(),
  email: e.string().nullable().optional(),
  emailVerified: e.boolean(),
  displayName: e.string().nullable().optional(),
  firstName: e.string().nullable().optional(),
  lastName: e.string().nullable().optional(),
  phone: e.string().nullable().optional(),
  role: e.string().nullable().optional(),
  isPlatformAdmin: e.boolean(),
  distributorId: e.number().int().nullable().optional(),
  distributorDisplayName: e.string().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  clientName: e.string().nullable().optional(),
  /** ISO-8601 Instant; null если KC не отдаёт createdTimestamp. */
  createdAt: e.string().nullable().optional(),
  /** Резерв; в KC 25 недоступен через UserRepresentation. */
  lastLoginAt: e.string().nullable().optional()
}), Ut = e.object({
  displayName: e.string().min(1).max(120).optional(),
  phone: e.string().max(64).regex(/^$|^[+()\-\s\d]{0,64}$/, "Допустимы цифры, пробел и символы + ( ) -").optional()
}).strict(), Lt = e.object({
  currentPassword: e.string().min(1, "Введите текущий пароль"),
  newEmail: e.string().min(1, "Введите новый email").email("Некорректный формат email").max(255)
}).strict(), Mt = e.object({
  currentPassword: e.string().min(1, "Введите текущий пароль"),
  newPassword: e.string().min(12, "Новый пароль должен быть не менее 12 символов")
}).strict(), u = (n) => e.object({
  content: e.array(n),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative(),
  number: e.number().int().nonnegative(),
  size: e.number().int().positive()
}), ne = e.enum([
  "DISTRIBUTOR_OWNER",
  "DISTRIBUTOR_ADMIN",
  "DISTRIBUTOR_MANAGER",
  "DISTRIBUTOR_FIELD_EMPLOYEE",
  "CLIENT_OWNER",
  "CLIENT_EMPLOYEE"
]), bi = ne, Ke = e.enum([
  "PENDING",
  "ACCEPTED",
  "EXPIRED",
  "REVOKED"
]), pi = Ke, _t = e.object({
  id: e.string(),
  kind: ne,
  distributorId: e.number().int().nullable(),
  clientId: e.number().int().nullable(),
  tradepointIds: e.array(e.number().int()).nullable().optional(),
  email: e.string().email(),
  suggestedFullName: e.string().nullable().optional(),
  suggestedUsername: e.string().nullable().optional(),
  state: Ke,
  createdByUserId: e.string(),
  createdAt: e.string(),
  expiresAt: e.string(),
  acceptedAt: e.string().nullable().optional()
}), Gt = e.object({
  tradepointId: e.number().int().positive(),
  warehouseId: e.number().int().positive()
}), zt = e.object({
  kind: ne,
  email: e.string().email(),
  distributorId: e.number().int().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  tradepointIds: e.array(e.number().int().positive()).nullable().optional(),
  suggestedFullName: e.string().max(255).nullable().optional(),
  suggestedUsername: e.string().max(255).nullable().optional(),
  /** TT-warehouse №2: применяется на accept'е, иначе backend бросит 400 для
   *  не-CLIENT_OWNER kind. Пусто/null — TT останутся без привязки. */
  tradepointWarehouseAssignments: e.array(Gt).nullable().optional()
}).strict(), Ht = e.object({
  id: e.string(),
  token: e.string(),
  expiresAt: e.string(),
  inviteUrl: e.string().url()
}), Bt = e.object({
  kind: ne,
  email: e.string().email(),
  suggestedFullName: e.string().nullable().optional(),
  suggestedUsername: e.string().nullable().optional(),
  expiresAt: e.string()
}), Vt = e.object({
  /** Пароль пользователя; минимум 8 символов, финальная policy у Keycloak. */
  password: e.string().min(8).max(255),
  /** Имя пользователя для отображения; pre-fill из suggestedFullName если есть. */
  displayName: e.string().min(1).max(255),
  /** Согласие с условиями обслуживания. */
  acceptTerms: e.literal(!0)
}).strict(), Ft = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  active: e.boolean(),
  primaryWarehouseId: e.number().int().nullable().optional(),
  primaryWarehouseName: e.string().nullable().optional()
}), Wt = e.object({
  /** {@code null} — отвязать склад (TT перейдёт в режим «всё под заказ»). */
  warehouseId: e.number().int().positive().nullable()
}), Yt = e.object({
  id: e.number().int(),
  externalId: e.string().uuid().nullable().optional(),
  name: e.string(),
  address: e.string().nullable().optional(),
  active: e.boolean()
}), Kt = e.enum(["HEALTHY", "DEGRADED", "DOWN"]), Qt = e.object({
  status: Kt,
  /** Последняя успешная синхронизация любого типа. */
  lastSyncAt: e.string().nullable().optional(),
  /** Последняя успешная Basic-auth 1С (exchange_credentials.last_used_at).
   *  Если новее lastSyncAt — 1С стучится, но цикл fail'ится после checkauth. */
  lastConnectionAttemptAt: e.string().nullable().optional(),
  /** Per-direction last successful sync. */
  lastCatalogSyncAt: e.string().nullable().optional(),
  lastOrdersInboundSyncAt: e.string().nullable().optional(),
  lastOrdersOutboundSyncAt: e.string().nullable().optional(),
  /** Per-direction stale: lastXxxSyncAt != null И старше per-direction threshold.
   *  Бэк делает сравнение, чтобы фронт не дублировал логику.
   *  null/undefined — направление не активировано (это не stale). */
  catalogStale: e.boolean().optional(),
  ordersInboundStale: e.boolean().optional(),
  ordersOutboundStale: e.boolean().optional(),
  /** Минут с последнего успешного синка — null если никогда не синкался. */
  staleMinutes: e.number().int().nonnegative().nullable().optional(),
  /** Общий threshold (минут), после которого статус → DEGRADED (default 24 ч). */
  degradedThresholdMinutes: e.number().int().positive().optional()
}), Jt = e.object({
  id: e.number().int(),
  distributorId: e.number().int(),
  login: e.string(),
  enabled: e.boolean(),
  /** ISO-8601 UTC. */
  createdAt: e.string(),
  /** ISO-8601 UTC; null — credentials никогда не использовались. */
  lastUsedAt: e.string().nullable().optional()
}), Xt = e.array(Jt), Qe = e.object({
  id: e.number().int(),
  login: e.string(),
  password: e.string(),
  note: e.string().optional().nullable()
}), Je = e.enum([
  "success",
  "failure",
  "progress",
  "in_flight",
  "aborted"
]), Zt = e.object({
  id: e.number().int(),
  requestId: e.string(),
  /** ISO-8601 UTC. */
  startedAt: e.string(),
  finishedAt: e.string().nullable().optional(),
  durationMs: e.number().int().nullable().optional(),
  httpMethod: e.string(),
  mode: e.string().nullable().optional(),
  type: e.string().nullable().optional(),
  httpStatus: e.number().int(),
  responseStatus: Je,
  bytesIn: e.number().int().nonnegative(),
  bytesOut: e.number().int().nonnegative(),
  errorCode: e.string().nullable().optional(),
  errorCategory: e.string().nullable().optional(),
  stagingFileId: e.string().uuid().nullable().optional(),
  /** PA-11 / D17 §2.6: cross-tenant обогащение для PLATFORM_ADMIN.
   *  Distributor-scoped пользователи получают null (контекст уже из JWT).
   *  Контракт симметричен OrderListItem. */
  distributorId: e.number().int().nullable().optional(),
  distributorSlug: e.string().nullable().optional(),
  distributorDisplayName: e.string().nullable().optional()
}), en = e.object({
  id: e.number().int(),
  distributorId: e.number().int().nullable().optional(),
  requestId: e.string(),
  startedAt: e.string(),
  finishedAt: e.string().nullable().optional(),
  durationMs: e.number().int().nullable().optional(),
  endpointPath: e.string(),
  httpMethod: e.string(),
  mode: e.string().nullable().optional(),
  type: e.string().nullable().optional(),
  queryParams: e.record(e.string()).nullable().optional(),
  httpStatus: e.number().int(),
  responseStatus: Je,
  bytesIn: e.number().int().nonnegative(),
  bytesOut: e.number().int().nonnegative(),
  requestSha256: e.string().nullable().optional(),
  responseSha256: e.string().nullable().optional(),
  stagingSessionId: e.string().uuid().nullable().optional(),
  stagingFileId: e.string().uuid().nullable().optional(),
  errorCode: e.string().nullable().optional(),
  errorCategory: e.string().nullable().optional(),
  errorMessage: e.string().nullable().optional(),
  metadata: e.record(e.unknown()).nullable().optional()
}), tn = e.object({
  subdomainSlug: e.string(),
  displayName: e.string().nullable().optional(),
  primaryColor: e.string().nullable().optional(),
  hasLogo: e.boolean()
}), nn = e.string().regex(/^$|^#[0-9a-fA-F]{6}$/, "Цвет должен быть в формате #RRGGBB"), V = e.object({
  version: e.number().int().nonnegative().safe(),
  subdomainSlug: e.string(),
  displayName: e.string().nullable().optional(),
  generalPhone: e.string().nullable().optional(),
  generalEmail: e.string().nullable().optional(),
  generalOfficeAddress: e.string().nullable().optional(),
  primaryColor: e.string().nullable().optional(),
  defaultPriceTypeExternal: e.string().uuid().nullable().optional(),
  hasLogo: e.boolean(),
  logoStorageKey: e.string().nullable().optional()
}), an = e.object({
  expectedVersion: e.number().int().nonnegative().safe(),
  displayName: e.string().max(255).optional(),
  generalPhone: e.string().max(64).optional(),
  generalEmail: e.union([e.string().email(), e.literal("")]).optional(),
  generalOfficeAddress: e.string().max(1024).optional(),
  primaryColor: nn.optional(),
  defaultPriceTypeExternal: e.string().uuid().optional(),
  clearDefaultPriceType: e.boolean().optional()
}).strict().refine((n) => !(n.clearDefaultPriceType && n.defaultPriceTypeExternal), {
  message: "Нельзя одновременно выбрать и очистить резервный вид цены",
  path: ["defaultPriceTypeExternal"]
}), rn = e.object({
  externalId: e.string().uuid().nullable(),
  name: e.string(),
  currency: e.string().nullable().optional(),
  isDefault: e.boolean()
}), on = (n) => e.object({
  content: e.array(n),
  number: e.number().int().nonnegative(),
  size: e.number().int().positive(),
  first: e.boolean(),
  last: e.boolean(),
  numberOfElements: e.number().int().nonnegative(),
  hasNext: e.boolean().optional()
}), sn = e.object({
  id: e.number().int(),
  name: e.string(),
  description: e.string().nullable().optional(),
  tradepointCount: e.number().int().nonnegative(),
  assignedUsersCount: e.number().int().nonnegative()
}), ln = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  clientId: e.number().int(),
  active: e.boolean()
}), cn = e.object({
  keycloakSub: e.string(),
  role: e.string(),
  active: e.boolean()
}), ae = e.object({
  id: e.number().int(),
  name: e.string(),
  description: e.string().nullable().optional(),
  tradepoints: e.array(ln),
  assignedUsers: e.array(cn)
}), un = e.object({
  name: e.string().min(1, "Название обязательно").max(255),
  description: e.string().max(2e3).nullable().optional(),
  tradepointIds: e.array(e.number().int()).optional()
}).strict(), dn = e.object({
  name: e.string().min(1, "Название обязательно").max(255),
  description: e.string().max(2e3).nullable().optional()
}).strict(), mn = e.object({
  tradepointIds: e.array(e.number().int()).min(1)
}).strict(), bn = e.object({
  id: e.number().int(),
  name: e.string()
}), pn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  pending: e.boolean(),
  active: e.boolean()
}), gn = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional()
}), Xe = e.object({
  lastTradepointId: e.number().int().nullable().optional(),
  availableTradepoints: e.array(gn)
}), yn = e.object({
  tradepointId: e.number().int().positive()
}).strict(), hn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  documentNumber: e.string().nullable().optional(),
  /** ISO-8601 OffsetDateTime; может быть null до синка из 1С. */
  documentDate: e.string().nullable().optional(),
  /** ISO-8601 Instant — момент создания записи в портале. */
  createdAt: e.string(),
  clientId: e.number().int().nullable().optional(),
  tradepointId: e.number().int().nullable().optional(),
  tradepointName: e.string().nullable().optional(),
  agreementId: e.number().int().nullable().optional(),
  agreementName: e.string().nullable().optional(),
  managerId: e.number().int().nullable().optional(),
  managerName: e.string().nullable().optional(),
  warehouseId: e.number().int().nullable().optional(),
  statusCode: e.string(),
  totalAmount: e.coerce.number(),
  currency: e.string(),
  /** ISO-8601 LocalDate. */
  deliveryDate: e.string().nullable().optional(),
  pending: e.boolean(),
  hasAttachments: e.boolean(),
  /** PA-11 / D17 §2.6: cross-tenant обогащение для PLATFORM_ADMIN.
   *  Для distributor-scoped / client-scoped пользователей — null. */
  distributorId: e.number().int().nullable().optional(),
  distributorSlug: e.string().nullable().optional(),
  distributorDisplayName: e.string().nullable().optional()
}), fn = u(hn), In = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  pending: e.boolean(),
  active: e.boolean()
}), Sn = u(In), wn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  inn: e.string().nullable().optional(),
  kpp: e.string().nullable().optional(),
  active: e.boolean()
}), vn = u(wn), En = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  active: e.boolean()
}), Pn = u(En), Tn = e.object({
  id: e.number().int(),
  agreementId: e.number().int(),
  skuExternalId: e.string().uuid(),
  price: e.coerce.number(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional()
}), An = u(Tn), Cn = e.object({
  skuId: e.number().int(),
  /** Внешний UUID-строка из 1С (может содержать '#offer' суффикс — до '#' это productExternalId). */
  externalId: e.string().nullable().optional(),
  productId: e.number().int().nullable().optional(),
  productSlug: e.string().nullable().optional(),
  name: e.string(),
  article: e.string().nullable().optional(),
  finalPrice: e.coerce.number().nullable().optional(),
  basePrice: e.coerce.number().nullable().optional(),
  discountApplied: e.boolean(),
  currency: e.string(),
  totalStock: e.coerce.number(),
  /**
   * Остаток на складе, привязанном к текущей TT (foundation chip
   * «TT-warehouse №1»). {@code null} — TT не привязана к складу
   * (no binding); 0 — связан, но нулевой остаток; положительное число —
   * доступно к моментальной отгрузке. {@code undefined} — backend ещё
   * не отдаёт поле (старый snapshot), UI падает на {@code totalStock}.
   */
  availableQuantity: e.coerce.number().nullable().optional(),
  /**
   * Производный флаг «в наличии» по TT-warehouse binding.
   * {@code undefined} — backend ещё не шипанул foundation.
   */
  isInStock: e.boolean().optional(),
  groupId: e.number().int().nullable().optional(),
  groupName: e.string().nullable().optional(),
  photoUrl: e.string().nullable().optional(),
  syncedAt: e.string().nullable().optional()
}), On = u(Cn), Rn = e.object({
  warehouseId: e.number().int(),
  warehouseExternalId: e.string().nullable().optional(),
  warehouseName: e.string().nullable().optional(),
  quantity: e.coerce.number()
}), jn = e.object({
  skuId: e.number().int(),
  externalId: e.string(),
  name: e.string().nullable().optional(),
  article: e.string().nullable().optional(),
  baseUnit: e.string().nullable().optional(),
  baseUnitCode: e.string().nullable().optional(),
  /** Коэффициент кратности заказа (D14 §6 «Quantity-quantization»). */
  baseUnitRatio: e.coerce.number().nullable().optional(),
  finalPrice: e.coerce.number().nullable().optional(),
  basePrice: e.coerce.number().nullable().optional(),
  discountApplied: e.boolean(),
  discountPercent: e.coerce.number().nullable().optional(),
  currency: e.string(),
  totalStock: e.coerce.number(),
  /**
   * Остаток на складе, привязанном к текущей TT (см. {@link SkuSearchItemSchema}).
   */
  availableQuantity: e.coerce.number().nullable().optional(),
  /** Производный флаг «в наличии» по TT-warehouse binding. */
  isInStock: e.boolean().optional(),
  stocks: e.array(Rn)
}), qn = e.object({
  id: e.number().int(),
  slug: e.string(),
  name: e.string(),
  article: e.string().nullable().optional(),
  description: e.string().nullable().optional(),
  categoryId: e.number().int().nullable().optional(),
  categoryName: e.string().nullable().optional(),
  /** Resolution chain product → category (S30 наполнит). В S29 — пустой массив. */
  photos: e.array(e.string()),
  skus: e.array(jn)
}), Ze = e.lazy(
  () => e.object({
    id: e.number().int(),
    externalId: e.string(),
    parentId: e.number().int().nullable(),
    name: e.string(),
    archived: e.boolean(),
    children: e.array(Ze)
  })
), Dn = e.object({
  id: e.number().int(),
  lineNumber: e.number().int(),
  skuExternalId: e.string().uuid(),
  skuId: e.number().int().nullable().optional(),
  skuArticle: e.string().nullable().optional(),
  skuName: e.string().nullable().optional(),
  quantity: e.coerce.number(),
  unitCode: e.string().nullable().optional(),
  price: e.coerce.number(),
  discountPercent: e.coerce.number().nullable().optional(),
  lineTotal: e.coerce.number(),
  /**
   * Позиция «под заказ» — в момент checkout привязанный склад TT не имел
   * остатка по SKU. Выставляется backend'ом автоматически (foundation chip
   * «TT-warehouse №1»). {@code undefined} — backend ещё не шипанул поле.
   */
  isBackorder: e.boolean().optional()
}), $n = e.object({
  id: e.number().int(),
  statusFrom: e.string().nullable().optional(),
  statusTo: e.string(),
  occurredAt: e.string(),
  actor: e.string().nullable().optional(),
  comment: e.string().nullable().optional()
}), Nn = e.object({
  id: e.number().int(),
  fileName: e.string().nullable().optional(),
  contentType: e.string().nullable().optional(),
  sizeBytes: e.coerce.number(),
  kind: e.string().nullable().optional(),
  sourceRevision: e.number().int().nullable().optional(),
  sourceModifiedAt: e.string().nullable().optional(),
  /** Отсутствует у backend старой версии во время rolling deployment. */
  current: e.boolean().optional()
}), xn = e.object({
  id: e.number().int(),
  editKind: e.string(),
  diff: e.record(e.string(), e.unknown()),
  occurredAt: e.string(),
  sourceSystem: e.string(),
  sourceRevision: e.number().int().nullable().optional(),
  requiresAck: e.boolean(),
  acknowledgedAt: e.string().nullable().optional()
}), re = e.object({
  id: e.number().int(),
  distributorId: e.number().int(),
  externalId: e.string().uuid(),
  documentNumber: e.string().nullable().optional(),
  documentDate: e.string().nullable().optional(),
  createdAt: e.string(),
  updatedAt: e.string().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  tradepointId: e.number().int().nullable().optional(),
  tradepointName: e.string().nullable().optional(),
  deliveryAddress: e.string().nullable().optional(),
  deliveryDate: e.string().nullable().optional(),
  legalEntityId: e.number().int().nullable().optional(),
  legalEntityName: e.string().nullable().optional(),
  warehouseId: e.number().int().nullable().optional(),
  warehouseName: e.string().nullable().optional(),
  agreementId: e.number().int().nullable().optional(),
  agreementName: e.string().nullable().optional(),
  managerId: e.number().int().nullable().optional(),
  managerName: e.string().nullable().optional(),
  managerPhone: e.string().nullable().optional(),
  managerEmail: e.string().nullable().optional(),
  statusCode: e.string(),
  totalAmount: e.coerce.number(),
  subtotalAmount: e.coerce.number(),
  discountAmount: e.coerce.number(),
  currency: e.string(),
  pending: e.boolean(),
  comment: e.string().nullable().optional(),
  paymentForm: e.string().nullable().optional(),
  legalEntityAddress: e.string().nullable().optional(),
  externalRevision: e.number().int().nullable().optional(),
  lines: e.array(Dn),
  statusEvents: e.array($n),
  attachments: e.array(Nn),
  editEvents: e.array(xn).default([]),
  etag: e.string()
}), kn = e.object({
  skuExternalId: e.string().uuid(),
  skuName: e.string().nullable().optional(),
  reason: e.string()
}), Un = e.object({
  targetTradepointId: e.number().int(),
  sourceTradepointId: e.number().int().nullable().optional(),
  added: e.number().int().nonnegative(),
  skipped: e.array(kn)
}), ge = e.enum([
  "DISTRIBUTOR_ADMIN",
  "DISTRIBUTOR_OWNER",
  "DISTRIBUTOR_MANAGER",
  "DISTRIBUTOR_FIELD_EMPLOYEE"
]), et = e.object({
  keycloakSub: e.string(),
  email: e.string().nullable().optional(),
  fullName: e.string().nullable().optional(),
  role: ge,
  territoryId: e.number().int().nullable().optional(),
  territoryName: e.string().nullable().optional(),
  managerId: e.string().nullable().optional(),
  managerName: e.string().nullable().optional(),
  // D19-1 / E1.2: связь user → DistributorManager (1С-Сотрудник). Backend
  // (E1.2 §B) будет наполнять — пока optional, frontend безопасно читает.
  distributorManagerId: e.number().int().nullable().optional(),
  distributorManagerName: e.string().nullable().optional(),
  active: e.boolean()
}), F = et, Ln = e.object({
  email: e.string().email(),
  fullName: e.string().min(1).max(255),
  role: ge,
  territoryId: e.number().int().nullable().optional(),
  managerId: e.string().nullable().optional(),
  // D19-1 / E1.2: связь приглашённого MANAGER с 1С-Сотрудником
  // (DistributorManager). Обязательна для роли MANAGER —
  // см. superRefine ниже.
  distributorManagerId: e.number().int().nullable().optional()
}).strict().superRefine((n, a) => {
  n.role === "DISTRIBUTOR_FIELD_EMPLOYEE" && n.territoryId == null && a.addIssue({
    code: e.ZodIssueCode.custom,
    path: ["territoryId"],
    message: "Территория обязательна для FIELD_EMPLOYEE"
  }), n.role === "DISTRIBUTOR_FIELD_EMPLOYEE" && !n.managerId && a.addIssue({
    code: e.ZodIssueCode.custom,
    path: ["managerId"],
    message: "Менеджер обязателен для FIELD_EMPLOYEE"
  }), n.role === "DISTRIBUTOR_MANAGER" && n.distributorManagerId == null && a.addIssue({
    code: e.ZodIssueCode.custom,
    path: ["distributorManagerId"],
    message: "1С-Сотрудник обязателен для роли MANAGER"
  });
}), Mn = e.object({
  user: F,
  loginUrl: e.string(),
  temporaryPassword: e.string(),
  emailDispatched: e.boolean()
}), _n = e.object({
  role: ge.optional(),
  territoryId: e.number().int().nullable().optional(),
  managerId: e.string().nullable().optional(),
  // D19-1 / E1.2: смена связи с 1С-Сотрудником (или сброс через null).
  distributorManagerId: e.number().int().nullable().optional()
}).strict(), Gn = e.object({
  id: e.number().int().nullable().optional(),
  skuExternalId: e.string().uuid("skuExternalId должен быть UUID"),
  quantity: e.number().positive("Кол-во должно быть больше нуля"),
  unitCode: e.string().max(16).nullable().optional(),
  price: e.number().nonnegative("Цена не может быть отрицательной").optional(),
  discountPercent: e.number().min(0, "Скидка не может быть отрицательной").max(100, "Скидка не более 100%").nullable().optional()
}).strict(), zn = e.object({
  agreementId: e.number().int().nullable().optional(),
  deliveryDate: e.string().nullable().optional(),
  clearDeliveryDate: e.boolean().nullable().optional(),
  deliveryAddress: e.string().max(1e3).nullable().optional(),
  managerId: e.number().int().nullable().optional(),
  comment: e.string().max(4e3).nullable().optional(),
  lines: e.array(Gn).nullable().optional()
}).strict(), Hn = e.object({
  reason: e.string().max(1e3).optional()
}).strict(), Bn = e.object({
  clientId: e.number().int().positive(),
  tradepointId: e.number().int().positive(),
  legalEntityId: e.number().int().positive(),
  agreementId: e.number().int().positive(),
  skuId: e.number().int().positive(),
  quantity: e.number().positive(),
  unitPrice: e.number().positive(),
  deliveryDate: e.string().date().nullable().optional(),
  deliveryAddress: e.string().max(1e3).nullable().optional(),
  comment: e.string().max(2e3).nullable().optional()
}).strict(), Vn = e.object({
  orderId: e.number().int().positive(),
  documentNumber: e.string().nullable(),
  externalId: e.string().uuid(),
  outboundEventId: e.number().int().positive(),
  statusCode: e.string().min(1)
}), Fn = e.enum(["REPRICE", "CANCEL", "REASSIGN_MANAGER", "SET_STATUS"]), Wn = e.object({
  orderIds: e.array(e.number().int().positive()).min(1).max(100),
  action: Fn,
  params: e.record(e.string(), e.unknown()).optional()
}).strict(), Yn = e.object({
  orderId: e.number().int().positive(),
  errorCode: e.string(),
  message: e.string().nullable().optional()
}), Kn = e.object({
  successCount: e.number().int().min(0),
  failedCount: e.number().int().min(0),
  failures: e.array(Yn)
}), Qn = e.object({
  clientId: e.number().int().positive(),
  name: e.string().min(1, "Название обязательно").max(255),
  currency: e.string().length(3).optional().nullable(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  paymentTermsDays: e.number().int().min(0).nullable().optional(),
  basePriceTypeExternal: e.string().uuid().nullable().optional()
}).strict(), Jn = e.object({
  id: e.number().int(),
  distributorId: e.number().int(),
  clientId: e.number().int(),
  externalId: e.string().uuid(),
  name: e.string(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  paymentTermsDays: e.number().int().nullable().optional(),
  basePriceTypeExternal: e.string().uuid().nullable().optional(),
  draft: e.boolean(),
  active: e.boolean()
}), Xn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  active: e.boolean()
}), Zn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid().nullable().optional(),
  fullName: e.string().nullable().optional(),
  email: e.string().nullable().optional(),
  phone: e.string().nullable().optional(),
  positionTitle: e.string().nullable().optional(),
  active: e.boolean()
}), ea = e.object({
  contacts: e.boolean(),
  logo: e.boolean(),
  territory: e.boolean(),
  invite: e.boolean()
}), ta = e.object({
  newOrders: e.number().int().nonnegative(),
  pendingOrders: e.number().int().nonnegative(),
  hierarchyWarnings: e.number().int().nonnegative(),
  onboardingCompleted: ea.nullable()
}), na = e.enum([
  "ORDER_NEW",
  "ORDER_EDITED",
  "ORDER_CANCELLED",
  "ORDER_REPRICED",
  "ORDER_STATUS_CHANGED",
  "INVITE_SENT",
  "INVITE_ACCEPTED",
  "INVITE_REVOKED",
  "USER_ROLE_CHANGED",
  "USER_DEACTIVATED",
  "TERRITORY_CREATED",
  "TERRITORY_UPDATED",
  "SETTINGS_UPDATED",
  "LOGO_UPLOADED",
  "AGREEMENT_DRAFT_CREATED",
  "HIERARCHY_WARNING",
  "INTEGRATION_ERROR"
]), aa = e.object({
  id: e.string(),
  kind: na,
  title: e.string(),
  subtitle: e.string().nullable(),
  url: e.string().nullable(),
  actor: e.string(),
  occurredAt: e.string()
}), ra = e.array(aa), tt = e.string().max(64, "Не более 64 символов").optional(), ye = e.string().max(255, "Не более 255 символов").refine((n) => n === "" || e.string().email().safeParse(n).success, {
  message: "Некорректный формат email"
}).optional(), ia = e.object({
  contactPhone: tt,
  contactEmail: ye
}).strict(), oa = e.object({
  contactPhone: tt,
  contactEmail: ye,
  address: e.string().max(1024, "Не более 1024 символов").optional()
}).strict(), sa = e.object({
  actualAddress: e.string().max(1024, "Не более 1024 символов").optional()
}).strict(), la = e.object({
  fullName: e.string().max(255, "Не более 255 символов").optional(),
  positionTitle: e.string().max(255, "Не более 255 символов").optional(),
  email: ye,
  phonePrimary: e.string().max(64, "Не более 64 символов").optional(),
  phoneSecondary: e.string().max(64, "Не более 64 символов").optional()
}).strict(), ca = e.object({
  id: e.number().int(),
  name: e.string(),
  contactPhone: e.string().nullable().optional(),
  contactEmail: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), ua = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  contactPhone: e.string().nullable().optional(),
  contactEmail: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), da = e.object({
  id: e.number().int(),
  name: e.string(),
  inn: e.string(),
  kpp: e.string().nullable().optional(),
  legalAddress: e.string().nullable().optional(),
  actualAddress: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), ma = e.object({
  id: e.number().int(),
  fullName: e.string(),
  positionTitle: e.string().nullable().optional(),
  email: e.string().nullable().optional(),
  phonePrimary: e.string().nullable().optional(),
  phoneSecondary: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), ba = e.object({
  /** ID шага — один из 8 фиксированных кодов (settings_filled,
   *  credentials_issued, credentials_delivered, first_sync_received,
   *  mass_sync_done, manager_invited, regular_sync_configured,
   *  client_owner_invited). */
  id: e.string(),
  /** Статус шага — рассчитан backend'ом из доменных таблиц. */
  status: e.enum(["done", "pending"])
}), pa = e.object({
  /** `true` ⇔ `distributor.onboarding_completed_at IS NOT NULL`. */
  completed: e.boolean(),
  /** ISO-8601 момент завершения wizard'а; `null`, если ещё не завершён. */
  completedAt: e.string().nullable(),
  /** Массив из 8 шагов (порядок фиксирован backend'ом — фронт может
   *  рендерить «as is»). */
  steps: e.array(ba),
  sourceProgress: e.object({
    credentialsIssued: e.boolean(),
    completedRuns: e.number().int().nonnegative(),
    confirmedBundles: e.number().int().nonnegative(),
    clients: e.number().int().nonnegative(),
    tradepoints: e.number().int().nonnegative(),
    payers: e.number().int().nonnegative()
  }).optional(),
  accessProgress: e.object({
    employees: e.number().int().nonnegative(),
    clientOwners: e.number().int().nonnegative()
  }).optional()
}), ga = e.object({
  clients: e.object({
    total: e.number().int().nonnegative(),
    pending: e.number().int().nonnegative()
  }),
  tradepoints: e.object({
    total: e.number().int().nonnegative(),
    withoutLegalEntity: e.number().int().nonnegative()
  }),
  managers: e.object({
    total: e.number().int().nonnegative(),
    withoutEmail: e.number().int().nonnegative()
  }),
  warehouses: e.object({
    total: e.number().int().nonnegative(),
    withStock: e.number().int().nonnegative()
  }),
  agreements: e.object({
    total: e.number().int().nonnegative(),
    withBasePrice: e.number().int().nonnegative()
  }),
  sku: e.object({
    total: e.number().int().nonnegative(),
    withProduct: e.number().int().nonnegative(),
    withStock: e.number().int().nonnegative()
  })
}), ya = e.object({
  id: e.number().int(),
  skuId: e.number().int(),
  skuExternalId: e.string(),
  skuArticle: e.string().nullable().optional(),
  skuName: e.string().nullable().optional(),
  unitName: e.string().nullable().optional(),
  /** Коэффициент кратности заказа (D14 §6 «Quantity-quantization»). */
  unitRatio: e.coerce.number().nullable().optional(),
  /** Кол-во в базовых единицах SKU; BigDecimal → coerce. */
  quantity: e.coerce.number(),
  /** Цена за единицу сейчас (recomputed: agreement → price-type → null). */
  unitPrice: e.coerce.number().nullable().optional(),
  basePrice: e.coerce.number().nullable().optional(),
  discountPercent: e.coerce.number().nullable().optional(),
  /** {@code unitPrice * quantity}; null если unitPrice отсутствует. */
  lineTotal: e.coerce.number().nullable().optional(),
  /** Snapshot цены на момент добавления строки (для UI badge «цена изменилась»). */
  snapshotUnitPrice: e.coerce.number().nullable().optional(),
  /** ISO Instant; null если строка добавлена без цены. */
  snapshotPricedAt: e.string().nullable().optional(),
  /**
   * D14 §8 — backend сравнивает {@code unitPrice} с {@code snapshotUnitPrice}
   * и выставляет {@code true} если цена изменилась с момента add-to-cart.
   * UI показывает badge «цена изменилась» pre-emptive (а не ждёт 409 на checkout).
   */
  priceChanged: e.boolean(),
  /** Остаток на TT-primary warehouse; null — нет привязки склада к TT. */
  availableQuantity: e.coerce.number().nullable().optional(),
  isInStock: e.boolean(),
  /**
   * Soft-флаг «под заказ» — TT-warehouse без binding ИЛИ
   * {@code quantity > availableQuantity}. Checkout пропускает, менеджер
   * подтверждает (D14 §7 «Quantity > остатка: soft warning ... checkout проходит»).
   */
  isBackorder: e.boolean(),
  /**
   * Hard-флаг «недоступен» — SKU archived/deleted (D14 §7 «Out-of-stock /
   * archived SKU: помечаем "недоступен", оставляем в строке, не считаем в total,
   * checkout с такой строкой блокирован»). Семантически отличается от
   * {@code isBackorder} — backorder проходит, unavailable блокирует.
   */
  isUnavailable: e.boolean(),
  photoUrl: e.string().nullable().optional()
}), gi = e.object({
  tradepointId: e.number().int(),
  lines: e.array(ya),
  /** Сумма {@code lineTotal} по всем строкам с unitPrice; BigDecimal → coerce. */
  totalAmount: e.coerce.number(),
  /** Сумма {@code quantity} по всем строкам; BigDecimal → coerce. */
  totalQuantity: e.coerce.number(),
  /** Кол-во строк с {@code isBackorder=true} — для total info-banner (D14 §7). */
  backorderCount: e.number().int(),
  /**
   * Кол-во строк с {@code isUnavailable=true} (archived/deleted SKU) —
   * для checkout-blocker banner (D14 §7).
   */
  unavailableCount: e.number().int(),
  currency: e.string()
}), yi = e.object({
  tradepointId: e.number().int(),
  skuId: e.number().int(),
  quantity: e.number().positive()
}).strict(), hi = e.object({
  quantity: e.number().positive()
}).strict();
async function fi(n, a) {
  const t = await n.request("/me", { token: a });
  return We.parse(t);
}
async function Ii(n, a, t) {
  const r = kt.parse(t), i = await n.request("/me", {
    method: "PATCH",
    token: a,
    body: r
  });
  return We.parse(i);
}
async function Si(n, a, t) {
  const r = Mt.parse(t);
  await n.request("/me/password", {
    method: "POST",
    token: a,
    body: r
  });
}
async function wi(n, a) {
  const t = await n.request("/me/profile", { token: a });
  return Ye.parse(t);
}
async function vi(n, a, t) {
  const r = Ut.parse(t), i = await n.request("/me/profile", {
    method: "PATCH",
    token: a,
    body: r
  });
  return Ye.parse(i);
}
async function Ei(n, a, t) {
  const r = Lt.parse(t);
  await n.request("/me/email", {
    method: "POST",
    token: a,
    body: r
  });
}
const ha = u(_t);
async function Pi(n, a, t) {
  const r = zt.parse(t), i = await n.request("/invitations", {
    method: "POST",
    token: a,
    body: r
  });
  return Ht.parse(i);
}
async function Ti(n, a, t = 0, r = 20) {
  const i = await n.request("/invitations", {
    token: a,
    query: { page: t, size: r }
  });
  return ha.parse(i);
}
async function Ai(n, a) {
  const t = await n.request(
    `/invitations/by-token/${encodeURIComponent(a)}`
  );
  return Bt.parse(t);
}
async function Ci(n, a, t) {
  const r = Vt.parse(t);
  await n.request(
    `/invitations/by-token/${encodeURIComponent(a)}/accept`,
    {
      method: "POST",
      body: r
    }
  );
}
async function Oi(n, a, t) {
  await n.request(`/invitations/${encodeURIComponent(t)}`, {
    method: "DELETE",
    token: a
  });
}
async function Ri(n, a) {
  await n.request("/auth/logout", {
    method: "POST",
    token: a
  });
}
async function ji(n, a) {
  const t = await n.request("/integration/1c/health", { token: a });
  return Qt.parse(t);
}
async function qi(n, a) {
  const t = await n.request("/me/exchange-credentials", { token: a });
  return Xt.parse(t);
}
async function Di(n, a) {
  const t = await n.request("/me/exchange-credentials", {
    method: "POST",
    token: a
  });
  return Qe.parse(t);
}
async function $i(n, a, t) {
  await n.request(
    `/admin/exchange-credentials/${t}/revoke`,
    { method: "POST", token: a }
  );
}
async function Ni(n, a, t = {}) {
  const r = await n.request("/admin/sync-events", {
    token: a,
    query: {
      distributorId: t.distributorId,
      since: t.since,
      until: t.until,
      // Multi-value: ApiClient повторит ключ для каждого элемента массива (см.
      // config.ts buildUrl). Spring биндит Set<String> из
      // `?responseStatus=success&responseStatus=failure`.
      responseStatus: t.responseStatus,
      type: t.type,
      mode: t.mode,
      requestId: t.requestId,
      errorCategory: t.errorCategory,
      errorCodePrefix: t.errorCodePrefix,
      hasWarnings: t.hasWarnings,
      durationMsMin: t.durationMsMin,
      durationMsMax: t.durationMsMax,
      page: t.page,
      size: t.size ?? 20
    }
  });
  return on(Zt).parse(r);
}
async function xi(n, a, t) {
  const r = await n.request(`/admin/sync-events/${t}`, { token: a });
  return en.parse(r);
}
async function ki(n, a, t = {}) {
  const r = await n.request("/admin/territories", {
    token: a,
    query: {
      name: t.name,
      page: t.page,
      size: t.size
    }
  });
  return u(sn).parse(r);
}
async function Ui(n, a, t) {
  const r = await n.request(`/admin/territories/${t}`, { token: a });
  return ae.parse(r);
}
async function Li(n, a, t) {
  const r = un.parse(t), i = await n.request("/admin/territories", {
    method: "POST",
    token: a,
    body: r
  });
  return ae.parse(i);
}
async function Mi(n, a, t, r) {
  const i = dn.parse(r), o = await n.request(`/admin/territories/${t}`, {
    method: "PATCH",
    token: a,
    body: i
  });
  return ae.parse(o);
}
async function _i(n, a, t) {
  await n.request(`/admin/territories/${t}`, {
    method: "DELETE",
    token: a
  });
}
async function Gi(n, a, t, r) {
  const i = mn.parse(r), o = await n.request(`/admin/territories/${t}/tradepoints`, {
    method: "POST",
    token: a,
    body: i
  });
  return ae.parse(o);
}
async function zi(n, a, t, r) {
  await n.request(
    `/admin/territories/${t}/tradepoints/${r}`,
    { method: "DELETE", token: a }
  );
}
async function Hi(n, a, t = {}) {
  const r = await n.request("/admin/tradepoints", {
    token: a,
    query: {
      name: t.name,
      clientIds: t.clientIds && t.clientIds.length > 0 ? t.clientIds : void 0,
      withoutTerritory: t.withoutTerritory,
      size: t.size ?? 200,
      page: t.page
    }
  });
  return u(pn).parse(r);
}
async function Bi(n, a, t = {}) {
  const r = await n.request("/admin/clients/lookup", {
    token: a,
    query: {
      name: t.name,
      size: t.size ?? 200,
      page: t.page
    }
  });
  return u(bn).parse(r);
}
async function Vi(n, a, t = {}) {
  const r = new URLSearchParams();
  t.distributorId != null && r.set("distributorId", String(t.distributorId)), t.clientId != null && r.set("clientId", String(t.clientId)), t.documentNumber && r.set("documentNumber", t.documentNumber), t.dateFrom && r.set("dateFrom", t.dateFrom), t.dateTo && r.set("dateTo", t.dateTo), t.totalAmountFrom != null && r.set("totalAmountFrom", String(t.totalAmountFrom)), t.totalAmountTo != null && r.set("totalAmountTo", String(t.totalAmountTo)), t.skuExternalId && r.set("skuExternalId", t.skuExternalId), t.page != null && r.set("page", String(t.page)), t.size != null && r.set("size", String(t.size)), t.sort && r.set("sort", t.sort);
  for (const l of t.statusCodes ?? []) r.append("statusCodes", l);
  for (const l of t.tradepointIds ?? []) r.append("tradepointIds", String(l));
  for (const l of t.clientIds ?? []) r.append("clientIds", String(l));
  for (const l of t.territoryIds ?? []) r.append("territoryIds", String(l));
  for (const l of t.managerIds ?? []) r.append("managerIds", String(l));
  const i = r.toString(), o = i.length === 0 ? "/orders" : `/orders?${i}`, s = await n.request(o, { token: a });
  return fn.parse(s);
}
async function Fi(n, a, t = {}) {
  const r = new URLSearchParams();
  r.set("format", "csv"), t.distributorId != null && r.set("distributorId", String(t.distributorId)), t.clientId != null && r.set("clientId", String(t.clientId)), t.documentNumber && r.set("documentNumber", t.documentNumber), t.dateFrom && r.set("dateFrom", t.dateFrom), t.dateTo && r.set("dateTo", t.dateTo), t.totalAmountFrom != null && r.set("totalAmountFrom", String(t.totalAmountFrom)), t.totalAmountTo != null && r.set("totalAmountTo", String(t.totalAmountTo)), t.skuExternalId && r.set("skuExternalId", t.skuExternalId);
  for (const c of t.statusCodes ?? []) r.append("statusCodes", c);
  for (const c of t.tradepointIds ?? []) r.append("tradepointIds", String(c));
  for (const c of t.clientIds ?? []) r.append("clientIds", String(c));
  for (const c of t.territoryIds ?? []) r.append("territoryIds", String(c));
  for (const c of t.managerIds ?? []) r.append("managerIds", String(c));
  const i = `${n.config.baseUrl}/orders/export?${r.toString()}`, o = globalThis.fetch, s = { Accept: "text/csv" };
  a && (s.Authorization = `Bearer ${a}`);
  const l = await o(i, { headers: s });
  if (!l.ok)
    throw new Error(`CSV-экспорт упал: HTTP ${l.status}`);
  return l.blob();
}
async function Wi(n, a, t, r) {
  const i = `${n.config.baseUrl}/orders/${t}`, o = n.config.fetch ?? globalThis.fetch, s = { Accept: "application/json" };
  a && (s.Authorization = `Bearer ${a}`), r != null && r.etag && (s["If-None-Match"] = `"${r.etag}"`);
  const l = await o(i, { headers: s });
  if (l.status === 304 && r)
    return { data: r.data, etag: r.etag, notModified: !0 };
  if (!l.ok) {
    let Q, J;
    try {
      const g = await l.json();
      Q = g == null ? void 0 : g.message, J = g == null ? void 0 : g.code;
    } catch {
    }
    throw new x(Q ?? `HTTP ${l.status}`, l.status, null, J);
  }
  const c = await l.json(), d = re.parse(c), G = (l.headers.get("etag") ?? `"${d.etag}"`).replace(/^"|"$/g, "");
  return { data: d, etag: G, notModified: !1 };
}
async function Yi(n, a, t, r) {
  const i = r === void 0 ? "" : `?tradepointId=${r}`, o = await n.request(`/orders/${t}/repeat${i}`, {
    method: "POST",
    token: a
  });
  return Un.parse(o);
}
async function Ki(n, a, t, r) {
  await n.request(`/orders/${t}/changes/${r}/ack`, {
    method: "POST",
    token: a
  });
}
function fa(n, a, t) {
  return `${n.config.baseUrl}/orders/${a}/attachments/${t}`;
}
async function Qi(n, a, t, r) {
  const i = fa(n, t, r), o = n.config.fetch ?? globalThis.fetch, s = {};
  a && (s.Authorization = `Bearer ${a}`);
  const l = await o(i, { headers: s });
  if (!l.ok)
    throw new x(
      `Не удалось скачать приложение: HTTP ${l.status}`,
      l.status,
      null
    );
  const c = await l.blob(), d = l.headers.get("content-disposition") ?? "", j = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(d), G = j && j[1] ? decodeURIComponent(j[1]) : `attachment-${r}.pdf`;
  return { blob: c, filename: G };
}
async function Ji(n, a, t = {}) {
  const r = new URLSearchParams();
  t.q && t.q.trim().length > 0 && r.set("q", t.q.trim()), t.inStock != null && r.set("inStock", String(t.inStock)), t.priceMin != null && r.set("priceMin", String(t.priceMin)), t.priceMax != null && r.set("priceMax", String(t.priceMax)), t.sort && r.set("sort", t.sort), t.tradePointId != null && r.set("tradePointId", String(t.tradePointId)), t.page != null && r.set("page", String(t.page)), t.size != null && r.set("size", String(t.size));
  for (const l of t.groupIds ?? []) r.append("groupIds", String(l));
  const i = r.toString(), o = i.length === 0 ? "/catalog/search" : `/catalog/search?${i}`, s = await n.request(o, { token: a });
  return On.parse(s);
}
async function Xi(n, a) {
  const t = await n.request("/catalog/categories", { token: a });
  return e.array(Ze).parse(t);
}
async function Zi(n, a, t, r = {}) {
  const i = new URLSearchParams();
  r.tradePointId != null && i.set("tradePointId", String(r.tradePointId));
  const o = i.toString(), s = o.length === 0 ? `/catalog/products/by-slug/${encodeURIComponent(t)}` : `/catalog/products/by-slug/${encodeURIComponent(t)}?${o}`, l = await n.request(s, { token: a });
  return qn.parse(l);
}
const Ia = e.object({
  skuId: e.number(),
  name: e.string().nullable(),
  article: e.string().nullable(),
  unitCode: e.string().nullable(),
  unitRatio: e.coerce.number().nullable(),
  unitName: e.string().nullable().optional()
}), he = e.object({
  tradepointId: e.number(),
  lines: e.array(e.object({
    id: e.number(),
    skuId: e.number(),
    quantity: e.string().regex(/^\d+(\.\d+)?$/),
    product: Ia.nullable(),
    unavailableReason: e.string().nullable()
  }))
}), Sa = e.object({
  membership: e.object({
    id: e.number(),
    distributorId: e.number(),
    subject: e.string(),
    role: e.enum(["CLIENT_OWNER", "CLIENT_EMPLOYEE", "DISTRIBUTOR_OWNER", "DISTRIBUTOR_EMPLOYEE"]),
    clientGroupId: e.number().nullable(),
    sourceManagerId: e.number().nullable(),
    state: e.enum(["PENDING", "ACTIVE", "BLOCKED"]),
    basePermissions: e.array(e.string()),
    version: e.number()
  }),
  permissions: e.array(e.string()),
  pairs: e.array(e.object({ tradepointId: e.number(), payerId: e.number() })),
  tradepoints: e.array(e.object({ id: e.number(), name: e.string(), address: e.string().nullable() })),
  payers: e.array(e.object({ id: e.number(), name: e.string(), inn: e.string().nullable() }))
});
async function eo(n, a, t) {
  return Sa.parse(await n.request("/portal/access/me", { token: a, signal: t }));
}
async function to(n, a, t, r) {
  return he.parse(await n.request(
    `/portal/cart/${t}`,
    { token: a, signal: r }
  ));
}
async function no(n, a, t) {
  return he.parse(await n.request(
    `/portal/cart/${t.tradepointId}/lines/${t.skuId}`,
    { token: a, method: "POST", body: { quantity: t.quantity } }
  ));
}
async function ao(n, a, t, r, i) {
  return he.parse(await n.request(
    `/portal/cart/${t}/lines/${r}`,
    { token: a, method: "PUT", body: i }
  ));
}
async function ro(n, a, t, r) {
  await n.request(`/portal/cart/${t}/lines/${r}`, { token: a, method: "DELETE" });
}
async function io(n, a, t) {
  await n.request(`/portal/cart/${t}`, { token: a, method: "DELETE" });
}
async function oo(n, a, t) {
  const r = Bn.parse(t), i = await n.request("/admin/orders/exchange-test", {
    method: "POST",
    token: a,
    body: r
  });
  return Vn.parse(i);
}
const q = e.string().regex(/^\d+(\.\d+)?$/), wa = e.object({
  quoteId: e.string().uuid(),
  expiresAt: e.string(),
  tradepointId: e.number(),
  tradepointName: e.string(),
  payerId: e.number(),
  payerName: e.string(),
  deliveryAddress: e.string(),
  deliveryDate: e.string().nullable(),
  comment: e.string().nullable(),
  currency: e.string(),
  total: q,
  canSubmit: e.boolean(),
  blockers: e.array(e.object({ code: e.string(), message: e.string() })),
  lines: e.array(e.object({
    skuId: e.number(),
    name: e.string(),
    article: e.string().nullable(),
    quantity: q,
    unitCode: e.string(),
    unitName: e.string().nullable().optional(),
    price: q,
    total: q,
    availableQuantity: q,
    stockReceivedAt: e.string(),
    stockCaptureStartedAt: e.string().datetime({ offset: !0 }).nullable().optional().default(null)
  }))
});
async function so(n, a, t) {
  return wa.parse(await n.request(
    "/portal/checkout/quotes",
    { token: a, method: "POST", body: t }
  ));
}
async function lo(n, a, t, r) {
  return e.object({
    orderId: e.number(),
    documentNumber: e.string().nullable(),
    statusCode: e.string(),
    totalAmount: q
  }).parse(await n.request(
    "/portal/checkout/confirm",
    { token: a, method: "POST", body: { quoteId: t, idempotencyKey: r } }
  ));
}
async function co(n, a) {
  const t = await n.request("/admin/dashboard/summary", { token: a });
  return ta.parse(t);
}
async function uo(n, a) {
  const t = await n.request("/admin/dashboard/activity", { token: a });
  return ra.parse(t);
}
async function mo(n, a) {
  const t = await n.request("/admin/distributor/settings", { token: a });
  return V.parse(t);
}
async function bo(n, a, t) {
  const r = an.parse(t), i = await n.request("/admin/distributor/settings", {
    method: "PATCH",
    token: a,
    body: r
  });
  return V.parse(i);
}
async function po(n, a, t) {
  const r = new FormData();
  r.append("file", t);
  const i = await n.request("/admin/distributor/settings/logo", {
    method: "POST",
    token: a,
    body: r
  });
  return V.parse(i);
}
async function go(n, a) {
  const t = await n.request("/admin/distributor/settings/logo", {
    method: "DELETE",
    token: a
  });
  return V.parse(t);
}
async function yo(n, a) {
  const t = await n.request("/admin/distributor/price-types", { token: a });
  return e.array(rn).parse(t);
}
async function ho(n, a) {
  const t = n.config.baseUrl, r = await fetch(`${t}/admin/distributor/settings/logo`, {
    headers: { Authorization: `Bearer ${a}` }
  });
  if (r.status === 404)
    return null;
  if (!r.ok)
    throw new Error(`Не удалось получить логотип: HTTP ${r.status}`);
  const i = await r.blob();
  return URL.createObjectURL(i);
}
async function fo(n, a) {
  try {
    const t = await n.request("/public/distributor-info", {
      query: { slug: a }
    });
    return tn.parse(t);
  } catch (t) {
    if (t instanceof x && t.status === 404)
      return null;
    throw t;
  }
}
function Io(n, a) {
  return `${n.config.baseUrl.replace(/\/+$/, "")}/public/distributor-info/logo?slug=${encodeURIComponent(a)}`;
}
const va = e.object({
  email: e.string(),
  distributorDisplayName: e.string(),
  distributorSlug: e.string(),
  /** ISO-8601 — момент истечения токена. UI может показать «действует до …». */
  expiresAt: e.string(),
  /** Статус инвайта (sent / accepted / expired / revoked / error). Backend
   *  на не-SENT отвечает 410 GONE, поэтому в живом ответе обычно SENT, но
   *  поле оставлено как страховка для будущих режимов. */
  status: e.string()
});
async function So(n, a) {
  const t = await n.request(
    `/public/platform-invitations/${encodeURIComponent(a)}`
  );
  return va.parse(t);
}
async function wo(n, a, t) {
  await n.request(
    `/public/platform-invitations/${encodeURIComponent(a)}/accept`,
    {
      method: "POST",
      body: { newPassword: t }
    }
  );
}
async function vo(n, a) {
  const t = await n.request("/me/context", { token: a });
  return Xe.parse(t);
}
async function Eo(n, a, t) {
  const r = yn.parse(t), i = await n.request("/me/context", {
    method: "PATCH",
    token: a,
    body: r
  });
  return Xe.parse(i);
}
async function Po(n, a, t) {
  const r = ia.parse(t), i = await n.request("/me/client/contacts", {
    method: "PATCH",
    token: a,
    body: r
  });
  return ca.parse(i);
}
async function To(n, a, t, r) {
  const i = oa.parse(r), o = await n.request(
    `/me/tradepoints/${t}/contacts`,
    { method: "PATCH", token: a, body: i }
  );
  return ua.parse(o);
}
async function Ao(n, a, t, r) {
  const i = sa.parse(r), o = await n.request(
    `/me/legal-entities/${t}/contacts`,
    { method: "PATCH", token: a, body: i }
  );
  return da.parse(o);
}
async function Co(n, a, t, r) {
  const i = la.parse(r), o = await n.request(`/me/contacts/${t}`, {
    method: "PATCH",
    token: a,
    body: i
  });
  return ma.parse(o);
}
function ie(n) {
  const a = new URLSearchParams();
  n.page != null && a.set("page", String(n.page)), n.size != null && a.set("size", String(n.size)), n.sort && a.set("sort", n.sort);
  const t = a.toString();
  return t.length === 0 ? "" : `?${t}`;
}
async function Oo(n, a, t = {}) {
  const r = await n.request(`/me/tradepoints${ie(t)}`, {
    token: a
  });
  return Sn.parse(r);
}
async function Ro(n, a, t = {}) {
  const r = await n.request(`/me/payers${ie(t)}`, {
    token: a
  });
  return vn.parse(r);
}
async function jo(n, a, t = {}) {
  const r = await n.request(`/me/agreements${ie(t)}`, {
    token: a
  });
  return Pn.parse(r);
}
async function qo(n, a, t, r = {}) {
  const i = await n.request(
    `/me/agreements/${t}/personal-prices${ie(r)}`,
    { token: a }
  );
  return An.parse(i);
}
async function Do(n, a, t) {
  const r = `${n.config.baseUrl}/me/agreements/${t}/personal-prices/export?format=csv`, i = globalThis.fetch, o = { Accept: "text/csv" };
  a && (o.Authorization = `Bearer ${a}`);
  const s = await i(r, { headers: o });
  if (!s.ok)
    throw new Error(`CSV-экспорт цен упал: HTTP ${s.status}`);
  return s.blob();
}
async function $o(n, a, t = {}) {
  const r = await n.request("/admin/distributor-users", {
    token: a,
    query: {
      roles: t.roles,
      territoryId: t.territoryId,
      active: t.active,
      search: t.search,
      distributorManagerId: t.distributorManagerId,
      page: t.page,
      size: t.size
    }
  });
  return u(et).parse(r);
}
async function No(n, a, t) {
  const r = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}`,
    { token: a }
  );
  return F.parse(r);
}
async function xo(n, a, t) {
  const r = Ln.parse(t), i = await n.request("/admin/distributor-users/invite", {
    method: "POST",
    token: a,
    body: r
  });
  return Mn.parse(i);
}
async function ko(n, a, t, r) {
  const i = _n.parse(r), o = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}`,
    {
      method: "PATCH",
      token: a,
      body: i
    }
  );
  return F.parse(o);
}
async function Uo(n, a, t) {
  const r = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}/deactivate`,
    { method: "POST", token: a }
  );
  return F.parse(r);
}
async function Lo(n, a, t) {
  const r = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}/activate`,
    { method: "POST", token: a }
  );
  return F.parse(r);
}
async function Mo(n, a, t) {
  await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}`,
    { method: "DELETE", token: a }
  );
}
async function _o(n, a, t, r, i) {
  const o = zn.parse(r), s = await n.request(`/admin/orders/${t}`, {
    method: "PATCH",
    token: a,
    body: o,
    headers: i ? { "If-Match": `"${i}"` } : void 0
  });
  return re.parse(s);
}
async function Go(n, a, t, r, i) {
  const o = await n.request(`/admin/orders/${t}/reprice`, {
    method: "POST",
    token: a,
    query: r == null ? void 0 : { agreementId: r },
    headers: i ? { "If-Match": `"${i}"` } : void 0
  });
  return re.parse(o);
}
async function zo(n, a, t, r = {}, i) {
  const o = Hn.parse(r), s = await n.request(`/admin/orders/${t}/cancel`, {
    method: "POST",
    token: a,
    body: o,
    headers: i ? { "If-Match": `"${i}"` } : void 0
  });
  return re.parse(s);
}
async function Ho(n, a, t) {
  const r = Wn.parse(t), i = await n.request("/admin/orders/bulk", {
    method: "POST",
    token: a,
    body: r
  });
  return Kn.parse(i);
}
const nt = e.object({
  id: e.number(),
  name: e.string(),
  active: e.boolean(),
  portalOwnedOverlay: e.boolean()
}), Ea = u(nt);
async function Bo(n, a, t = {}) {
  const r = await n.request("/admin/clients", {
    method: "GET",
    token: a,
    query: {
      overlay: t.overlay,
      includePending: t.includePending,
      // Spring биндит List<Long> из repeated query-параметра с одинаковым именем.
      primaryWarehouseId: t.primaryWarehouseIds,
      page: t.page,
      size: t.size,
      sort: t.sort
    }
  });
  return Ea.parse(r);
}
async function Vo(n, a, t) {
  await n.request(`/admin/clients/${t}/reset-overlay`, {
    method: "POST",
    token: a
  });
}
async function Fo(n, a, t) {
  await n.request(`/admin/tradepoints/${t}/reset-overlay`, {
    method: "POST",
    token: a
  });
}
async function Wo(n, a, t) {
  await n.request(
    `/admin/legal-entities/${t}/reset-overlay`,
    { method: "POST", token: a }
  );
}
async function Yo(n, a, t) {
  await n.request(`/admin/contacts/${t}/reset-overlay`, {
    method: "POST",
    token: a
  });
}
async function Ko(n, a, t) {
  const r = await n.request(`/admin/clients/${t}`, {
    method: "GET",
    token: a
  });
  return nt.parse(r);
}
async function Qo(n, a, t) {
  const r = await n.request(
    `/admin/clients/${t}/tradepoints`,
    { method: "GET", token: a }
  );
  return e.array(Ft).parse(r);
}
async function Jo(n, a, t, r, i) {
  const o = Wt.parse(i);
  await n.request(
    `/admin/clients/${t}/tradepoints/${r}/warehouse`,
    { method: "PATCH", token: a, body: o }
  );
}
const Pa = u(Yt);
async function Xo(n, a, t = {}) {
  const r = await n.request("/admin/warehouses", {
    method: "GET",
    token: a,
    query: {
      name: t.name,
      active: t.active,
      page: t.page,
      size: t.size,
      sort: t.sort
    }
  });
  return Pa.parse(r);
}
const Ta = e.object({
  legalEntityId: e.number().nullable(),
  tradepointId: e.number().nullable(),
  clientId: e.number().nullable(),
  confidence: e.number(),
  breakdown: e.array(e.string())
}), Aa = e.object({
  candidates: e.array(Ta),
  runAt: e.string(),
  threshold: e.number(),
  algorithmVersion: e.number()
}), Ca = e.object({
  id: e.number(),
  externalId: e.string(),
  documentNumber: e.string().nullable(),
  /** ISO-8601 OffsetDateTime. */
  documentDate: e.string().nullable(),
  /** ISO-8601 Instant. */
  createdAt: e.string(),
  /** BigDecimal as string — не теряем precision на больших суммах. */
  totalAmount: e.string(),
  currency: e.string(),
  deliveryAddress: e.string().nullable(),
  comment: e.string().nullable(),
  matchCandidates: Aa.nullable()
}), Oa = u(Ca);
async function Zo(n, a, t = {}) {
  const r = await n.request("/admin/orders/pending", {
    method: "GET",
    token: a,
    query: {
      page: t.page,
      size: t.size,
      sort: t.sort
    }
  });
  return Oa.parse(r);
}
const Ra = e.object({
  clientId: e.number(),
  tradepointId: e.number(),
  legalEntityId: e.number(),
  warehouseId: e.number().optional().nullable(),
  managerId: e.number().optional().nullable()
});
async function es(n, a, t, r) {
  const i = Ra.parse(r);
  await n.request(`/admin/orders/${t}/link`, {
    method: "POST",
    token: a,
    body: i
  });
}
const ja = e.object({
  id: e.number().int(),
  slug: e.string(),
  externalId: e.string(),
  name: e.string(),
  article: e.string().nullable(),
  barcode: e.string().nullable(),
  categoryId: e.number().int().nullable(),
  categoryName: e.string().nullable(),
  isPublished: e.boolean(),
  hasOwnPhoto: e.boolean(),
  photoCount: e.number().int().nonnegative()
}), qa = u(ja), at = e.object({
  id: e.number().int(),
  storageKey: e.string(),
  sortOrder: e.number().int().nonnegative(),
  altText: e.string().nullable()
}), rt = e.object({
  id: e.number().int(),
  storageKey: e.string(),
  sortOrder: e.number().int().nonnegative(),
  altText: e.string().nullable(),
  createdAt: e.string()
}), Da = e.object({
  affected: e.number().int().nonnegative(),
  skipped: e.number().int().nonnegative()
}), $a = e.object({
  slug: e.string().min(1, "Slug не может быть пустым").max(96, "Slug не должен быть длиннее 96 символов").regex(
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    "Slug должен состоять из строчных букв, цифр и дефисов"
  )
}).strict(), Na = e.object({
  published: e.boolean()
}).strict();
async function ts(n, a, t = {}) {
  const r = {};
  t.categoryId != null && (r.categoryId = t.categoryId), t.published != null && (r.published = t.published), t.hasPhoto != null && (r.hasPhoto = t.hasPhoto), t.orphanSku != null && (r.orphanSku = t.orphanSku), t.search && t.search.trim().length > 0 && (r.search = t.search.trim()), t.page != null && (r.page = t.page), t.size != null && (r.size = t.size);
  const i = await n.request("/admin/catalog/products", {
    token: a,
    query: r
  });
  return qa.parse(i);
}
async function ns(n, a, t) {
  const r = await n.request(
    `/admin/catalog/products/${t}/photos`,
    { token: a }
  );
  return e.array(rt).parse(r);
}
async function as(n, a, t) {
  const r = await n.request(
    `/admin/catalog/categories/${t}/photos`,
    { token: a }
  );
  return e.array(rt).parse(r);
}
async function rs(n, a, t) {
  const r = n.config.baseUrl, i = await fetch(`${r}/admin/catalog/photos/${t}/binary`, {
    headers: { Authorization: `Bearer ${a}` }
  });
  if (!i.ok)
    throw new Error(`Не удалось получить фото #${t}: HTTP ${i.status}`);
  const o = await i.blob();
  return URL.createObjectURL(o);
}
async function is(n, a, t, r, i = {}) {
  const o = new FormData();
  o.append("file", r), i.sortOrder != null && o.append("sortOrder", String(i.sortOrder)), i.altText != null && o.append("altText", i.altText);
  const s = await n.request(
    `/admin/catalog/products/${t}/photos`,
    { method: "POST", token: a, body: o }
  );
  return at.parse(s);
}
async function os(n, a, t, r) {
  await n.request(
    `/admin/catalog/products/${t}/photos/${r}`,
    { method: "DELETE", token: a }
  );
}
async function ss(n, a, t, r, i = {}) {
  const o = new FormData();
  o.append("file", r), i.sortOrder != null && o.append("sortOrder", String(i.sortOrder)), i.altText != null && o.append("altText", i.altText);
  const s = await n.request(
    `/admin/catalog/categories/${t}/photos`,
    { method: "POST", token: a, body: o }
  );
  return at.parse(s);
}
async function ls(n, a, t, r) {
  await n.request(
    `/admin/catalog/categories/${t}/photos/${r}`,
    { method: "DELETE", token: a }
  );
}
async function cs(n, a, t, r) {
  const i = await n.request(
    `/admin/catalog/categories/${t}/apply-photos-to-products`,
    { method: "POST", token: a, query: { force: r } }
  );
  return Da.parse(i);
}
async function us(n, a, t, r) {
  const i = Na.parse({ published: r });
  await n.request(
    `/admin/catalog/products/${t}/publication`,
    { method: "PATCH", token: a, body: i }
  );
}
async function ds(n, a, t, r) {
  const i = $a.parse({ slug: r });
  await n.request(`/admin/catalog/products/${t}/slug`, {
    method: "PATCH",
    token: a,
    body: i
  });
}
const xa = ["provisioning", "active", "archived"], W = e.string().transform((n) => n.toLowerCase()).pipe(e.enum(xa)), ka = ["sent", "accepted", "expired", "revoked", "error"], it = e.string().transform((n) => n.toLowerCase()).pipe(e.enum(ka)), Ua = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: W,
  /** ISO-8601 — дата создания записи `distributor`. */
  createdAt: e.string(),
  /** ISO-8601 — последний логин первого OWNER'а (null если ни разу). */
  lastOwnerLoginAt: e.string().nullable().optional(),
  /** ISO-8601 — последний успешный sync 1С (null если ни разу). */
  lastSyncAt: e.string().nullable().optional(),
  /** Кол-во заказов за сегодня. */
  ordersToday: e.number().int().nonnegative().default(0)
}), La = u(Ua), Ma = e.object({
  cardCreatedAt: e.string().nullable().optional(),
  subdomainReadyAt: e.string().nullable().optional(),
  inviteSentAt: e.string().nullable().optional(),
  ownerAcceptedAt: e.string().nullable().optional(),
  credentialsIssuedAt: e.string().nullable().optional(),
  firstSyncAt: e.string().nullable().optional()
}), _a = e.object({
  userId: e.string().nullable().optional(),
  email: e.string(),
  firstName: e.string().nullable().optional(),
  lastName: e.string().nullable().optional(),
  inviteStatus: it,
  inviteSentAt: e.string().nullable().optional(),
  inviteAcceptedAt: e.string().nullable().optional(),
  inviteExpiresAt: e.string().nullable().optional()
}), fe = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: W,
  inn: e.string().nullable().optional(),
  generalPhone: e.string().nullable().optional(),
  generalEmail: e.string().nullable().optional(),
  generalOfficeAddress: e.string().nullable().optional(),
  createdAt: e.string(),
  /** Можно ли выполнить hard-delete (D16 §2.3) — backend сам считает: нет
   *  accepted invite И нет sync_event записей. */
  canHardDelete: e.boolean(),
  checklist: Ma,
  owner: _a.nullable().optional()
}), Ga = e.object({
  slug: e.string(),
  available: e.boolean(),
  /** Локализованная причина если не available (например «slug занят»,
   *  «slug зарезервирован»). */
  reason: e.string().nullable().optional()
}), za = /^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/, Ha = e.object({
  slug: e.string().min(3, "Slug должен быть не короче 3 символов").max(32, "Slug должен быть не длиннее 32 символов").regex(
    za,
    "Только lowercase, цифры и дефисы; не может начинаться или заканчиваться дефисом"
  ),
  displayName: e.string().min(1, "Укажите название тенанта").max(255),
  inn: e.string().regex(/^\d{10}$|^\d{12}$/, "ИНН должен содержать 10 или 12 цифр"),
  generalPhone: e.string().max(64).optional().nullable(),
  generalEmail: e.string().email("Некорректный email").optional().nullable(),
  generalOfficeAddress: e.string().max(500).optional().nullable(),
  ownerEmail: e.string().email("Некорректный email OWNER").max(255),
  ownerFirstName: e.string().min(1, "Укажите имя OWNER").max(120),
  ownerLastName: e.string().min(1, "Укажите фамилию OWNER").max(120),
  /** Если ИНН уже занят другим тенантом — backend вернёт 409 с warning
   *  kind='duplicate_inn'. После подтверждения пользователем — клиент
   *  повторяет POST с этим флагом, и backend записывает (D16 §2.6). */
  confirmDuplicateInn: e.boolean().optional()
}).strict(), Ba = e.object({
  kind: e.literal("duplicate_inn"),
  existingDistributor: e.object({
    id: e.number().int(),
    displayName: e.string(),
    slug: e.string()
  })
}), Va = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: W,
  ownerUserId: e.string(),
  /** URL на welcome-страницу admin SPA с onboarding-token; PA копирует и
   *  шлёт OWNER через защищённый канал (Telegram / WhatsApp). По клику OWNER
   *  попадает на нашу welcome-форму, задаёт пароль и логинится. */
  inviteLink: e.string().url().nullable().optional(),
  /** D16-v2: SMTP отключён → всегда false. Оставлено в схеме для backward
   *  compatibility с уже задеплоенным backend; UI не использует. */
  smtpFallback: e.boolean().default(!1),
  /** Заполняется при confirmed duplicate_inn (D16 §2.6). UI рендерит
   *  info-banner и редиректит на карточку. */
  warning: Ba.nullable().optional()
}), Fa = e.object({
  invitationId: e.number().int(),
  status: it,
  sentAt: e.string(),
  expiresAt: e.string(),
  /** URL на welcome-страницу admin SPA с onboarding-token; PA копирует и
   *  шлёт OWNER через защищённый канал. */
  inviteLink: e.string().url().nullable().optional(),
  /** D16-v2: SMTP отключён → всегда false. Поле оставлено для backward compat. */
  smtpFallback: e.boolean().default(!1)
}), Wa = e.object({
  ownerEmail: e.string().email("Некорректный email").max(255),
  ownerFirstName: e.string().min(1, "Укажите имя OWNER").max(128),
  ownerLastName: e.string().min(1, "Укажите фамилию OWNER").max(128)
}).strict(), Ya = e.object({
  distributorId: e.number().int(),
  newOwnerSub: e.string(),
  previousOwnerSubs: e.array(e.string()).default([]),
  invitationId: e.number().int(),
  /** URL на welcome-страницу admin SPA с onboarding-token; PA копирует и
   *  шлёт OWNER через защищённый канал. */
  inviteLink: e.string().url().nullable().optional(),
  /** D16-v2: SMTP отключён → всегда false. Поле оставлено для backward compat. */
  smtpFallback: e.boolean().default(!1)
}), Ka = e.object({
  status: W,
  comment: e.string().min(1, "Укажите причину изменения статуса").max(2e3)
}).strict();
async function ms(n, a, t = {}) {
  const r = await n.request("/admin/platform/distributors", {
    token: a,
    query: {
      status: t.status,
      search: t.search,
      stuckSinceDays: t.stuckSinceDays,
      page: t.page,
      size: t.size
    }
  });
  return La.parse(r);
}
async function bs(n, a, t) {
  const r = await n.request(`/admin/platform/distributors/${t}`, {
    token: a
  });
  return fe.parse(r);
}
async function ps(n, a, t) {
  const r = await n.request("/admin/platform/distributors/check", {
    token: a,
    query: { slug: t }
  });
  return Ga.parse(r);
}
async function gs(n, a, t) {
  const r = Ha.parse(t), i = await n.request("/admin/platform/distributors", {
    method: "POST",
    token: a,
    body: r
  });
  return Va.parse(i);
}
async function ys(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/invitations/resend`,
    { method: "POST", token: a }
  );
  return Fa.parse(r);
}
async function hs(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/archive`,
    { method: "POST", token: a }
  );
  return fe.parse(r);
}
async function fs(n, a, t) {
  await n.request(`/admin/platform/distributors/${t}`, {
    method: "DELETE",
    token: a
  });
}
async function Is(n, a, t, r) {
  const i = Ka.parse(r), o = await n.request(
    `/admin/platform/distributors/${t}/status`,
    { method: "POST", token: a, body: i }
  );
  return fe.parse(o);
}
async function Ss(n, a, t, r) {
  const i = Wa.parse(r), o = await n.request(
    `/admin/platform/distributors/${t}/owner`,
    { method: "POST", token: a, body: i }
  );
  return Ya.parse(o);
}
function ws(n) {
  const a = n.trim();
  if (a.length !== 10 && a.length !== 12 || !/^\d+$/.test(a)) return !1;
  const t = a.split("").map((o) => Number(o));
  if (a.length === 10)
    return me(t, [2, 4, 10, 3, 5, 9, 4, 6, 8]) === t[9];
  const r = me(t, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]), i = me(t, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
  return r === t[10] && i === t[11];
}
function me(n, a) {
  let t = 0;
  for (let r = 0; r < a.length; r++)
    t += n[r] * a[r];
  return t % 11 % 10;
}
const Qa = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: W
}), Ja = e.object({
  id: e.number().int(),
  documentNumber: e.string(),
  distributorId: e.number().int(),
  distributorSlug: e.string(),
  /** Backend сериализует `OrderStatus#name()` lowercase'ом (см. order-domain),
   *  но защищаемся от UPPERCASE'а на случай drift'а — нормализуем тут же. */
  statusCode: e.string().transform((n) => n.toLowerCase()),
  /** ISO-8601 OffsetDateTime создания заказа. */
  createdAt: e.string()
}), Xa = e.object({
  distributors: e.array(Qa).default([]),
  orders: e.array(Ja).default([])
});
async function vs(n, a, t) {
  const r = await n.request("/admin/platform/search", {
    token: a,
    query: { q: t }
  });
  return Xa.parse(r);
}
const Za = e.object({
  id: e.number().int(),
  documentNumber: e.string(),
  /** Backend сериализует `OrderStatus#name()` lowercase'ом, но защищаемся от
   *  UPPERCASE-drift'а — нормализуем тут же (как в platform-search). */
  statusCode: e.string().transform((n) => n.toLowerCase()),
  /** Сумма заказа в копейках/рублях — Zod парсит number; backend отдаёт BigDecimal
   *  через Jackson как scalar (без { value }). */
  totalAmount: e.number(),
  currency: e.string(),
  /** ISO-8601 момент создания заказа (`Instant.toString()`). */
  createdAt: e.string()
}), er = e.object({
  id: e.number().int(),
  name: e.string(),
  active: e.boolean(),
  pending: e.boolean()
}), tr = e.object({
  id: e.number().int(),
  name: e.string(),
  /** Address optional — у некоторых ТТ его нет (1С не присылает). */
  address: e.string().nullable().optional(),
  clientId: e.number().int(),
  active: e.boolean()
}), nr = e.object({
  id: e.number().int(),
  name: e.string().nullable().optional(),
  article: e.string().nullable().optional(),
  /** Может быть null для orphan-Sku (D07 — не сматчен с Product). */
  productId: e.number().int().nullable().optional()
}), ar = e.object({
  orders: e.array(Za).default([]),
  clients: e.array(er).default([]),
  tradepoints: e.array(tr).default([]),
  skus: e.array(nr).default([]),
  totalHits: e.number().int().default(0)
});
async function Es(n, a, t) {
  const r = await n.request("/admin/search", {
    token: a,
    query: { q: t }
  });
  return ar.parse(r);
}
async function Ps(n, a, t = {}) {
  const r = await n.request("/admin/agreements", {
    token: a,
    query: {
      clientId: t.clientId,
      active: t.active,
      name: t.name,
      page: t.page,
      size: t.size
    }
  });
  return u(Xn).parse(r);
}
async function Ts(n, a, t) {
  const r = Qn.parse(t), i = await n.request("/admin/agreements/draft", {
    method: "POST",
    token: a,
    body: r
  });
  return Jn.parse(i);
}
async function As(n, a, t = {}) {
  const r = await n.request("/admin/managers", {
    token: a,
    query: {
      fullName: t.fullName,
      email: t.email,
      active: t.active,
      page: t.page,
      size: t.size
    }
  });
  return u(Zn).parse(r);
}
const rr = e.object({
  id: e.number().int(),
  /** Тип операции, например `create_distributor` / `archive_distributor`. */
  action: e.string(),
  /** ID тенанта-цели; null для bootstrap-операций PA. */
  targetDistributorId: e.number().int().nullable().optional(),
  /** Subdomain slug тенанта-цели (batch-resolved); null если тенант удалён. */
  targetDistributorSlug: e.string().nullable().optional(),
  /** Человеческое название тенанта-цели; null при тех же условиях. */
  targetDistributorDisplayName: e.string().nullable().optional(),
  /** ISO-8601 Instant — когда выполнена операция (UTC). */
  performedAt: e.string(),
  /** KC sub PA, выполнившего операцию. */
  performedByUserId: e.string().uuid(),
  /** Snapshot username'а PA на момент операции (KC username мутабельный). */
  performedByUsername: e.string(),
  /** Человеко-читаемое имя PA — резолвится бекендом через KC (приоритет
   *  firstName+lastName → email → username). null если KC недоступен или
   *  user удалён; в этом случае frontend деградирует на performedByUsername.
   *  Audit follow-up post-merge review D-08 (зеркалит UX-DO-04/05 для
   *  distributor audit-log'а из PR #190). */
  performedByDisplayName: e.string().nullable().optional(),
  /** Свободные метаданные операции (payload JSONB как есть). Будущая
   *  redaction чувствительных полей — Phase 2 (D16 §2.13). */
  payload: e.record(e.unknown()).nullable().optional()
}), ot = u(rr);
async function Cs(n, a, t = {}) {
  const r = await n.request("/admin/platform/audit-log", {
    token: a,
    query: {
      actor: t.actor,
      action: t.action,
      targetDistributorId: t.targetDistributorId,
      since: t.since,
      until: t.until,
      page: t.page,
      size: t.size
    }
  });
  return ot.parse(r);
}
async function Os(n, a, t, r = {}) {
  const i = await n.request(
    `/admin/platform/distributors/${t}/audit-log`,
    {
      token: a,
      query: {
        actor: r.actor,
        action: r.action,
        since: r.since,
        until: r.until,
        page: r.page,
        size: r.size
      }
    }
  );
  return ot.parse(i);
}
const st = e.object({
  id: e.number().int(),
  /** Тип операции (например invite_sent / order_edited / territory_created). */
  action: e.string(),
  /** Тип цели (user / order / settings / territory / agreement / ...);
   *  null для безтаргетных событий. */
  targetKind: e.string().nullable().optional(),
  /** ID цели; null для безтаргетных событий. */
  targetId: e.number().int().nullable().optional(),
  /** KC sub actor'а. */
  actorUserId: e.string(),
  /** Человеко-читаемое имя actor'а (full_name / email из user_link).
   *  null если sub не сматчен в user_link — UI деградирует в short-UUID /
   *  «(Система)». UX-DO-04/05 follow-up. */
  actorDisplayName: e.string().nullable().optional(),
  /** Snapshot realm-роли actor'а на момент действия
   *  (DISTRIBUTOR_OWNER / DISTRIBUTOR_MANAGER / ...). */
  actorRole: e.string(),
  /** ISO-8601 — когда выполнена операция (UTC). */
  occurredAt: e.string(),
  /** Свободные метаданные (payload JSONB как есть). */
  payload: e.record(e.unknown()).nullable().optional()
}), ir = u(st);
async function Rs(n, a, t = {}) {
  const r = await n.request("/admin/audit-log", {
    token: a,
    query: {
      actorUserId: t.actorUserId,
      action: t.action,
      actionPrefix: t.actionPrefix,
      targetKind: t.targetKind,
      since: t.since,
      until: t.until,
      page: t.page,
      size: t.size
    }
  });
  return ir.parse(r);
}
async function js(n, a, t) {
  const r = await n.request(`/admin/audit-log/${t}`, { token: a });
  return st.parse(r);
}
async function qs(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/exchange-credentials/issue`,
    { method: "POST", token: a }
  );
  return Qe.parse(r);
}
async function Ds(n, a, t) {
  await n.request(
    `/admin/platform/exchange-credentials/${t}/revoke`,
    { method: "POST", token: a }
  );
}
const or = e.object({
  keycloakSub: e.string(),
  email: e.string(),
  fullName: e.string().nullable(),
  /** "OWNER" | "ADMIN" | "MANAGER" | "FIELD_EMPLOYEE" — но backend может
   *  расширить список ролей, поэтому здесь свободная строка. */
  primaryRole: e.string(),
  territoryName: e.string().nullable(),
  active: e.boolean(),
  /** ISO-8601 — дата создания KC-пользователя. */
  createdAt: e.string()
});
async function $s(n, a, t, r = {}) {
  const i = await n.request(
    `/admin/platform/distributors/${t}/users`,
    { token: a, query: { page: r.page, size: r.size } }
  );
  return u(or).parse(i);
}
async function Ns(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/settings`,
    { token: a }
  );
  return V.parse(r);
}
const sr = e.enum([
  "HIERARCHY_WARNING",
  "SYNC_ERROR",
  "PENDING_ORDER",
  "INVITE_ACCEPTED",
  "PLATFORM_TENANT_ACTIVATED",
  "PLATFORM_SYNC_FAILURE"
]), lr = e.object({
  id: e.number().int(),
  kind: sr,
  title: e.string(),
  /** Расширенное описание / контекст; может отсутствовать. */
  body: e.string().nullable().optional(),
  /**
   * Внутренний URL admin SPA для перехода (например `/orders/pending`).
   *
   * Hardening (P1-C2 post-merge audit): принимаем только относительные пути,
   * начинающиеся с одного `/`, не с `//`. Защита от open-redirect: если
   * backend (по багу или атаке) подсунет `https://evil.example/phish` или
   * protocol-relative `//evil.example/...`, zod вернёт `undefined` (через
   * `.catch(undefined)`), и frontend безопасно проигнорирует это поле.
   */
  linkUrl: e.string().regex(/^\/(?!\/)/, "linkUrl должен быть относительным путём, начинающимся с /").nullable().optional().catch(void 0),
  /** ISO-8601 — когда событие произошло (UTC). */
  occurredAt: e.string(),
  /** ISO-8601 — когда отмечено прочитанным; `null` для непрочитанных. */
  readAt: e.string().nullable().optional()
}), cr = u(lr), ur = e.object({
  count: e.number().int().nonnegative()
}), dr = e.object({
  marked: e.number().int().nonnegative()
});
async function xs(n, a, t = {}) {
  const r = await n.request("/admin/notifications", {
    token: a,
    query: {
      unreadOnly: t.unreadOnly,
      kind: t.kind,
      page: t.page,
      size: t.size
    }
  });
  return cr.parse(r);
}
async function ks(n, a, t) {
  await n.request(`/admin/notifications/${t}/read`, {
    token: a,
    method: "POST"
  });
}
async function Us(n, a) {
  const t = await n.request("/admin/notifications/read-all", {
    token: a,
    method: "POST"
  });
  return dr.parse(t);
}
async function Ls(n, a) {
  const t = await n.request("/admin/notifications/unread-count", {
    token: a
  });
  return ur.parse(t);
}
async function Ms(n, a) {
  const t = await n.request("/admin/onboarding/state", { token: a });
  return pa.parse(t);
}
async function _s(n, a) {
  await n.request("/admin/onboarding/complete", { token: a, method: "POST" });
}
async function Gs(n, a) {
  await n.request("/admin/onboarding/mark-credentials-delivered", {
    token: a,
    method: "POST"
  });
}
async function zs(n, a) {
  const t = await n.request("/admin/sync-state/summary", { token: a });
  return ga.parse(t);
}
const mr = e.object({
  mode: e.enum(["EXISTING", "CREATE"]),
  groupId: e.number().int().positive().nullable(),
  name: e.string().min(1).max(160),
  version: e.number().int().nonnegative().nullable()
}), Ge = e.object({
  externalId: e.string().uuid(),
  name: e.string(),
  active: e.boolean(),
  deliveryAddress: e.string().nullable()
}), br = e.object({
  externalId: e.string().uuid(),
  ownerExternalId: e.string().uuid(),
  name: e.string(),
  inn: e.string().nullable(),
  active: e.boolean()
}), oe = e.object({
  id: e.string().uuid(),
  connectionId: e.string().uuid(),
  runId: e.string().uuid(),
  version: e.number().int().nonnegative(),
  clientId: e.number().nullable(),
  createdAt: e.string(),
  confirmedAt: e.string().nullable(),
  snapshot: e.object({
    client: Ge,
    tradepoints: e.array(Ge),
    payers: e.array(br),
    targetGroup: mr.nullable().default(null),
    warnings: e.array(e.string()).default([])
  })
}), pr = e.object({
  content: e.array(e.object({ externalId: e.string(), payload: e.record(e.unknown()) })),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative()
}), gr = e.object({
  content: e.array(e.object({
    id: e.number().int().positive(),
    name: e.string(),
    active: e.boolean(),
    version: e.number().int().nonnegative()
  })),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative()
});
async function Hs(n, a, t, r = 0) {
  return gr.parse(await n.request(
    "/portal/mapping/reconciliations/client-groups",
    { token: a, query: { search: t, page: r, size: 20 } }
  ));
}
async function Bs(n, a, t, r, i, o, s = []) {
  const l = e.string().uuid().parse(t.connectionId), c = e.string().uuid().parse(t.runId);
  return pr.parse(await n.request(
    `/portal/source-runs/${l}/${c}/objects`,
    { token: a, query: { dataset: r, search: i, page: o, size: 20, relatedExternalIds: s } }
  ));
}
async function Vs(n, a, t) {
  return oe.parse(await n.request("/portal/mapping/previews", {
    token: a,
    method: "POST",
    body: t
  }));
}
async function Fs(n, a, t) {
  const r = e.string().uuid().parse(t.id);
  return oe.parse(await n.request(`/portal/mapping/previews/${r}/confirm`, {
    token: a,
    method: "POST",
    body: { expectedVersion: t.version }
  }));
}
async function Ws(n, a, t) {
  const r = e.string().uuid().parse(t);
  return oe.parse(await n.request(`/portal/mapping/previews/${r}`, { token: a }));
}
const yr = e.enum([
  "PARTNERS",
  "PAYERS",
  "MANAGERS",
  "CATEGORIES",
  "PRODUCTS",
  "SKUS",
  "PRICE_TYPES",
  "PRICES",
  "WAREHOUSES",
  "STOCKS",
  "ORDER_HISTORY",
  "AGREEMENTS",
  "CONTACTS"
]), Ie = e.object({ connectionId: e.string().uuid(), runId: e.string().uuid() }), hr = Ie.extend({
  completed: e.boolean(),
  createdAt: e.string().nullable(),
  completedAt: e.string().nullable()
}), fr = e.object({
  content: e.array(hr),
  totalPages: e.number().int().nonnegative(),
  number: e.number().int().nonnegative(),
  totalElements: e.number().int().nonnegative()
}), Ir = Ie.extend({
  completed: e.boolean(),
  datasets: e.array(e.object({
    dataset: yr,
    expectedObjects: e.number().int().nonnegative(),
    expectedChunks: e.number().int().nonnegative(),
    notApplicable: e.boolean(),
    receivedObjects: e.number().int().nonnegative(),
    receivedChunks: e.number().int().nonnegative(),
    completed: e.boolean()
  }))
});
async function Ys(n, a, t = 0) {
  return fr.parse(await n.request("/portal/source-runs", {
    token: a,
    query: { page: t, size: 20 }
  }));
}
async function Ks(n, a, t) {
  const r = Ie.parse(t);
  return Ir.parse(await n.request(
    `/portal/source-runs/${r.connectionId}/${r.runId}`,
    { token: a }
  ));
}
const lt = e.object({
  id: e.number().int().positive(),
  name: e.string(),
  active: e.boolean(),
  version: e.number().int().nonnegative()
}), ct = e.object({
  clientId: e.number().int().positive(),
  name: e.string(),
  sourceExternalId: e.string().uuid(),
  previewId: e.string().uuid()
}), Sr = e.object({
  groupId: e.number().int().positive(),
  configuredPairCount: e.number().int().nonnegative(),
  ownerInvitationAvailable: e.boolean()
}), wr = e.object({
  content: e.array(lt),
  totalPages: e.number().int(),
  totalElements: e.number().int()
}), vr = e.object({
  content: e.array(ct),
  totalPages: e.number().int(),
  totalElements: e.number().int()
});
async function Qs(n, a, t, r) {
  return wr.parse(await n.request("/portal/client-groups", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
async function Js(n, a, t, r) {
  return vr.parse(await n.request("/portal/client-groups/candidates", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
async function Xs(n, a, t, r) {
  return lt.parse(await n.request("/portal/client-groups", {
    token: a,
    method: "POST",
    body: { name: t, clientIds: r }
  }));
}
async function Zs(n, a, t) {
  return e.number().int().positive().parse(t), e.array(ct).parse(await n.request(`/portal/client-groups/${t}/clients`, { token: a }));
}
async function el(n, a, t) {
  return e.number().int().positive().parse(t), Sr.parse(
    await n.request(`/portal/client-groups/${t}/access-readiness`, { token: a })
  );
}
const y = e.number().int().positive(), v = e.string().uuid(), Se = e.enum(["CLIENT_OWNER", "CLIENT_EMPLOYEE"]), ut = e.object({ tradepointId: y, payerId: y }), we = e.object({
  id: v,
  groupId: y,
  role: Se,
  email: e.string(),
  name: e.string(),
  expiresAt: e.string().datetime({ offset: !0 }),
  state: e.enum(["PENDING", "ACCEPTED", "REVOKED", "EXPIRED"]),
  pairs: e.array(ut),
  equalGroupOwner: e.boolean(),
  canCreateOrders: e.boolean()
}), Er = e.object({
  tradepointId: y,
  tradepointName: e.string().nullable(),
  address: e.string().nullable(),
  payerId: y,
  payerName: e.string().nullable(),
  inn: e.string().nullable()
}), Pr = e.object({
  invitation: we,
  groupName: e.string(),
  distributorName: e.string().nullable(),
  distributorSubdomain: e.string(),
  pairLabels: e.array(Er)
}), Y = e.object({
  id: y,
  distributorId: y,
  subject: v,
  role: e.enum(["CLIENT_OWNER", "CLIENT_EMPLOYEE", "DISTRIBUTOR_OWNER", "DISTRIBUTOR_EMPLOYEE"]),
  clientGroupId: y.nullable(),
  sourceManagerId: y.nullable(),
  state: e.enum(["PENDING", "ACTIVE", "BLOCKED"]),
  basePermissions: e.array(e.string()),
  version: e.number().int().nonnegative()
}), Tr = e.object({
  requestId: v,
  groupId: y,
  role: Se,
  email: e.string().trim().email().max(254),
  name: e.string().trim().min(1).max(200),
  pairs: e.array(ut).max(500),
  canCreateOrders: e.boolean(),
  confirmsOwnerAccess: e.boolean()
});
async function tl(n, a, t) {
  return e.object({ invitation: we, token: v }).parse(
    await n.request("/portal/group-invitations", {
      token: a,
      method: "POST",
      body: Tr.parse(t)
    })
  );
}
async function nl(n, a, t, r) {
  return e.array(we).parse(await n.request("/portal/group-invitations", {
    token: a,
    query: { groupId: y.parse(t), role: Se.parse(r) }
  }));
}
async function al(n, a, t) {
  await n.request(`/portal/group-invitations/${v.parse(t)}`, { token: a, method: "DELETE" });
}
async function rl(n, a, t) {
  return Pr.parse(await n.request(
    `/invitations/by-token/${v.parse(a)}/group`,
    {
      signal: t,
      cache: "no-store",
      referrerPolicy: "no-referrer"
    }
  ));
}
async function il(n, a, t, r) {
  const i = e.object({ password: e.string().min(8).max(128), consent: e.literal(!0) }).parse({ password: t, consent: r });
  return e.object({ status: e.enum(["LOGIN_REQUIRED", "LOGIN_EXISTING_ACCOUNT"]) }).parse(
    await n.request(`/invitations/by-token/${v.parse(a)}/group/register`, {
      method: "POST",
      body: i,
      cache: "no-store",
      referrerPolicy: "no-referrer"
    })
  );
}
async function ol(n, a, t) {
  return Y.parse(await n.request(
    `/invitations/by-token/${v.parse(t)}/group/accept`,
    {
      token: a,
      method: "POST",
      body: { confirmed: !0 },
      cache: "no-store",
      referrerPolicy: "no-referrer"
    }
  ));
}
function sl(n, a) {
  const t = new URL("/group-invite", n);
  if (!["https:", "http:"].includes(t.protocol)) throw new Error("Нужен HTTP(S) адрес портала");
  return t.hash = v.parse(a), t.toString();
}
const Ar = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
class D extends Error {
}
function dt(n) {
  try {
    return n ?? globalThis.sessionStorage;
  } catch {
    throw new D("Хранилище вкладки недоступно. Разрешите его перед выдачей приглашения; восстановление после перезагрузки иначе невозможно.");
  }
}
function pe(n) {
  return `dss.group-invitation-attempt:${n}`;
}
async function ll(n, a, t) {
  const r = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(a)), i = Array.from(new Uint8Array(r), (s) => s.toString(16).padStart(2, "0")).join(""), o = dt(t);
  try {
    const s = o.getItem(pe(n));
    if (s) {
      const c = JSON.parse(s);
      if (c && typeof c == "object" && "requestId" in c && "hash" in c && typeof c.requestId == "string" && Ar.test(c.requestId) && typeof c.hash == "string") {
        if (c.hash === i) return c.requestId;
        throw new D("Есть незавершённая попытка с другими данными. Повторите прежние поля для восстановления ссылки или сначала проверьте список и явно завершите предыдущую попытку.");
      }
      throw new D("Не удалось восстановить предыдущую попытку. Сначала проверьте список приглашений и явно завершите её.");
    }
    const l = crypto.randomUUID();
    return o.setItem(pe(n), JSON.stringify({ requestId: l, hash: i })), l;
  } catch (s) {
    throw s instanceof D ? s : new D("Не удалось сохранить ключ попытки. Разрешите хранилище вкладки; без него нельзя обещать восстановление после перезагрузки.");
  }
}
function cl(n, a) {
  try {
    dt(a).removeItem(pe(n));
  } catch {
    throw new D("Не удалось завершить сохранённую попытку. Проверьте список перед новой выдачей.");
  }
}
const w = e.string().uuid(), mt = e.number().int().positive(), ve = "/portal/distributor-employee-invitations", Ee = e.object({
  id: w,
  sourceManagerId: mt,
  sourceManagerExternalId: w,
  sourceManagerName: e.string(),
  role: e.literal("DISTRIBUTOR_EMPLOYEE"),
  email: e.string(),
  name: e.string(),
  expiresAt: e.string().datetime({ offset: !0 }),
  state: e.enum(["PENDING", "ACCEPTED", "REVOKED", "EXPIRED"])
}), Cr = e.object({
  invitation: Ee,
  distributorName: e.string().nullable(),
  distributorSubdomain: e.string()
}), Or = e.object({
  requestId: w,
  sourceManagerId: mt,
  email: e.string().trim().email().max(254),
  name: e.string().trim().min(1).max(200)
});
async function ul(n, a, t) {
  return e.object({ invitation: Ee, token: w }).parse(
    await n.request(ve, { token: a, method: "POST", body: Or.parse(t) })
  );
}
async function dl(n, a) {
  return e.array(Ee).parse(await n.request(ve, { token: a }));
}
async function ml(n, a, t) {
  await n.request(`${ve}/${w.parse(t)}`, { token: a, method: "DELETE" });
}
async function bl(n, a, t) {
  return Cr.parse(await n.request(
    `/invitations/by-token/${w.parse(a)}/employee`,
    { signal: t, cache: "no-store", referrerPolicy: "no-referrer" }
  ));
}
async function pl(n, a, t, r) {
  const i = e.object({ password: e.string().min(8).max(128), consent: e.literal(!0) }).parse({ password: t, consent: r });
  return e.object({ status: e.enum(["LOGIN_REQUIRED", "LOGIN_EXISTING_ACCOUNT"]) }).parse(
    await n.request(
      `/invitations/by-token/${w.parse(a)}/employee/register`,
      { method: "POST", body: i, cache: "no-store", referrerPolicy: "no-referrer" }
    )
  );
}
async function gl(n, a, t) {
  return Y.parse(await n.request(
    `/invitations/by-token/${w.parse(t)}/employee/accept`,
    {
      token: a,
      method: "POST",
      body: { confirmed: !0 },
      cache: "no-store",
      referrerPolicy: "no-referrer"
    }
  ));
}
function yl(n, a) {
  const t = new URL("/employee-invite", n);
  if (!["https:", "http:"].includes(t.protocol)) throw new Error("Нужен HTTP(S) адрес портала");
  return t.hash = w.parse(a), t.toString();
}
const m = e.number().int().positive(), Z = e.string().regex(/^-?\d+(\.\d+)?$/), Rr = e.enum([
  "permission_missing",
  "policy_disabled",
  "source_snapshot_missing",
  "mutation_pending",
  "source_window_unverified",
  "operation_adapter_not_verified"
]), ze = e.object({ allowed: e.literal(!1), reasons: e.array(Rr).min(1).refine((n) => n.includes("source_window_unverified") && n.includes("operation_adapter_not_verified")) }), jr = e.object({
  policyVersion: e.number().int().nonnegative(),
  edit: ze,
  cancel: ze
});
async function hl(n, a, t, r) {
  return m.parse(t), jr.parse(await n.request(
    `/portal/orders/${t}/operation-availability`,
    { token: a, signal: r }
  ));
}
const bt = e.object({
  id: m,
  externalId: e.string().uuid(),
  documentNumber: e.string().nullable(),
  documentDate: e.string().nullable(),
  createdAt: e.string(),
  origin: e.enum(["UNKNOWN", "SOURCE", "PORTAL"]),
  clientId: m.nullable(),
  tradepointId: m.nullable(),
  legalEntityId: m.nullable(),
  statusCode: e.string(),
  sourceStatusName: e.string().nullable().optional().default(null),
  totalAmount: Z,
  currency: e.string(),
  deliveryAddress: e.string().nullable(),
  deliveryDate: e.string().nullable(),
  comment: e.string().nullable(),
  pending: e.boolean(),
  externalRevision: e.number().int().nullable(),
  syncedAt: e.string().nullable(),
  currentTradepointName: e.string().nullable(),
  currentPayerName: e.string().nullable()
}), qr = e.object({
  order: bt,
  lines: e.array(e.object({
    id: m,
    lineNumber: e.number().int(),
    skuExternalId: e.string().uuid(),
    name: e.string().nullable(),
    article: e.string().nullable(),
    unitCode: e.string().nullable(),
    unitName: e.string().nullable().optional(),
    quantity: Z,
    price: Z,
    lineTotal: Z
  })),
  statusEvents: e.array(e.object({
    id: m,
    statusFrom: e.string().nullable(),
    statusTo: e.string(),
    occurredAt: e.string(),
    actor: e.string().nullable(),
    comment: e.string().nullable()
  })),
  attachments: e.array(e.object({
    id: m,
    fileName: e.string().nullable(),
    contentType: e.string().nullable(),
    sizeBytes: e.number().nonnegative(),
    kind: e.string(),
    sourceRevision: e.number().int(),
    sourceModifiedAt: e.string().nullable(),
    current: e.literal(!0)
  })),
  attachmentsAllowed: e.boolean(),
  sourceConfirmation: e.object({
    connectionId: e.string().uuid(),
    generation: e.number().int().positive(),
    revision: e.string().regex(/^[1-9]\d*$/),
    receivedAt: e.string(),
    sourceModifiedAt: e.string().nullable(),
    snapshotId: m
  }).nullable().optional().default(null)
}), Dr = e.object({
  clientEditAllowed: e.boolean(),
  clientCancelAllowed: e.boolean(),
  employeeEditAllowed: e.boolean(),
  employeeCancelAllowed: e.boolean()
}), ee = e.object({
  clientHistoryVisible: e.boolean(),
  version: e.number().int().nonnegative(),
  clientEditAllowed: e.boolean().optional(),
  clientCancelAllowed: e.boolean().optional(),
  employeeEditAllowed: e.boolean().optional(),
  employeeCancelAllowed: e.boolean().optional()
}), $r = e.object({ command: e.object({
  eventId: e.number().int().positive(),
  kind: e.string(),
  state: e.string(),
  outcome: e.enum(["APPLIED", "REJECTED", "CONFLICT"]).nullable(),
  connectionId: e.string().uuid().nullable(),
  generation: e.number().int().positive().nullable(),
  sourceOrderId: e.string().uuid().nullable(),
  resultRevision: e.string().regex(/^[1-9]\d*$/).nullable(),
  errorCode: e.string().nullable(),
  receivedAt: e.string().nullable()
}).nullable() });
async function fl(n, a, t, r) {
  return $r.parse(await n.request(
    `/portal/orders/${m.parse(t)}/command-status`,
    { token: a, signal: r }
  ));
}
const Nr = e.object({
  id: e.string().uuid(),
  connectionId: e.string().uuid(),
  sourceOrderId: e.string().uuid(),
  generation: e.number().int().positive(),
  revision: e.string().regex(/^[1-9]\d*$/),
  templateId: e.string(),
  templateVersion: e.string(),
  fileName: e.string(),
  sha256: e.string(),
  sizeBytes: e.number().int().nonnegative(),
  receivedAt: e.string(),
  state: e.literal("CURRENT"),
  replayed: e.literal(!1)
});
async function Il(n, a, t, r) {
  return e.array(Nr).parse(await n.request(
    `/portal/orders/${m.parse(t)}/source-assets`,
    { token: a, signal: r }
  ));
}
async function Sl(n, a, t, r, i) {
  const o = typeof window > "u" ? "http://localhost" : window.location.origin, s = new URL(`${n.config.baseUrl}/portal/orders/${m.parse(t)}/source-assets/${e.string().uuid().parse(r)}/download`, o), l = await (n.config.fetch ?? fetch)(s.toString(), {
    headers: { Authorization: `Bearer ${a}` },
    cache: "no-store",
    signal: i
  });
  if (!l.ok) throw new x("Не удалось получить текущий PDF заказа", l.status);
  return l.blob();
}
async function wl(n, a, t = {}, r) {
  return e.object({
    content: e.array(bt),
    totalElements: e.number().int().nonnegative(),
    totalPages: e.number().int().nonnegative()
  }).parse(await n.request("/portal/orders", {
    token: a,
    query: { ...t, size: 20 },
    signal: r
  }));
}
async function vl(n, a, t, r) {
  return qr.parse(await n.request(`/portal/orders/${m.parse(t)}`, { token: a, signal: r }));
}
async function El(n, a) {
  return ee.parse(await n.request("/portal/order-policy", { token: a }));
}
async function Pl(n, a, t) {
  const r = ee.parse(t);
  return ee.parse(await n.request("/portal/order-policy", {
    token: a,
    method: "PUT",
    body: { expectedVersion: r.version, clientHistoryVisible: r.clientHistoryVisible }
  }));
}
async function Tl(n, a, t, r) {
  const i = Dr.parse(r);
  return ee.parse(await n.request("/portal/order-policy/mutations", {
    token: a,
    method: "PUT",
    body: { expectedVersion: e.number().int().nonnegative().parse(t), ...i }
  }));
}
async function Al(n, a, t, r, i) {
  const o = typeof window > "u" ? "http://localhost" : window.location.origin, s = new URL(`${n.config.baseUrl}/portal/orders/${m.parse(t)}/attachments/${m.parse(r)}`, o), l = await (n.config.fetch ?? fetch)(s.toString(), {
    headers: { Authorization: `Bearer ${a}` },
    cache: "no-store",
    signal: i
  });
  if (!l.ok) throw new x("Не удалось получить текущий файл заказа", l.status);
  return l.blob();
}
const Pe = e.object({ connectionId: e.string().uuid(), runId: e.string().uuid() }), He = e.object({
  dataset: e.string().nullable(),
  externalId: e.string().nullable(),
  code: e.string(),
  message: e.string()
}), pt = Pe.extend({
  contract: e.string(),
  canApply: e.boolean(),
  counts: e.record(e.number().int().nonnegative()),
  blockers: e.array(He),
  blockerCount: e.number().int().nonnegative(),
  diagnosticsTruncated: e.boolean(),
  warnings: e.array(He),
  warningCount: e.number().int().nonnegative(),
  appliedAt: e.string().nullable(),
  replayed: e.boolean()
});
async function Cl(n, a, t, r) {
  return pt.parse(await n.request("/portal/commercial/preview", {
    token: a,
    method: "POST",
    body: Pe.parse(t),
    signal: r
  }));
}
async function Ol(n, a, t) {
  return pt.parse(await n.request("/portal/commercial/apply", {
    token: a,
    method: "POST",
    body: Pe.parse(t)
  }));
}
const S = e.string().uuid(), Te = e.object({
  managerId: e.number().int().positive(),
  sourceExternalId: S,
  name: e.string(),
  active: e.boolean(),
  connectionId: S,
  runId: S
}), xr = e.object({
  connectionId: S,
  runId: S,
  managersApplied: e.number().int().nonnegative(),
  clientsResolved: e.number().int().nonnegative(),
  unresolvedCount: e.number().int().nonnegative(),
  blockedEmployees: e.number().int().nonnegative(),
  unresolved: e.array(e.object({
    clientId: e.number().int().positive(),
    clientName: e.string(),
    sourceClientExternalId: S,
    sourceManagerExternalId: S.nullable(),
    reason: e.string()
  }))
});
async function Rl(n, a, t) {
  const r = e.object({ connectionId: S, runId: S }).parse(t);
  return xr.parse(await n.request("/portal/source-managers/project", {
    token: a,
    method: "POST",
    body: r
  }));
}
async function jl(n, a, t = "", r = 0) {
  return e.object({
    content: e.array(Te),
    totalPages: e.number().int(),
    totalElements: e.number().int()
  }).parse(await n.request("/portal/source-managers/candidates", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
const N = e.number().int().positive(), se = e.number().int().nonnegative(), kr = e.object({ code: e.string(), label: e.string() }), k = e.object({
  membership: Y.extend({ blockReason: e.string().nullable() }),
  name: e.string().nullable(),
  email: e.string().nullable(),
  sourceManager: Te.nullable(),
  overrides: e.array(e.object({ code: e.string(), effect: e.enum(["GRANT", "DENY"]) })),
  effectivePermissions: e.array(e.string()),
  sessionRevocationPending: e.boolean()
});
async function ql(n, a, t = 0) {
  return e.object({
    content: e.array(k),
    totalPages: e.number().int(),
    totalElements: e.number().int()
  }).parse(await n.request("/portal/employees", {
    token: a,
    query: { page: t, size: 20 }
  }));
}
async function Dl(n, a, t) {
  return k.parse(await n.request(`/portal/employees/${N.parse(t)}`, { token: a }));
}
async function $l(n, a) {
  return e.array(kr).parse(await n.request("/portal/employees/permission-catalog", { token: a }));
}
async function Nl(n, a, t = "", r = 0) {
  return e.object({
    content: e.array(Te),
    totalPages: e.number().int(),
    totalElements: e.number().int()
  }).parse(await n.request("/portal/employees/source-managers", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
async function xl(n, a, t, r) {
  return k.parse(await n.request(`/portal/employees/${N.parse(t)}/block`, {
    token: a,
    method: "POST",
    body: { expectedVersion: se.parse(r) }
  }));
}
async function kl(n, a, t, r) {
  return k.parse(await n.request(`/portal/employees/${N.parse(t)}/restore`, {
    token: a,
    method: "POST",
    body: { expectedVersion: se.parse(r), confirmed: !0 }
  }));
}
async function Ul(n, a, t, r, i) {
  return k.parse(await n.request(`/portal/employees/${N.parse(t)}/source-manager`, {
    token: a,
    method: "PUT",
    body: { expectedVersion: se.parse(r), sourceManagerId: N.parse(i) }
  }));
}
async function Ll(n, a, t, r, i, o) {
  return k.parse(await n.request(`/portal/employees/${N.parse(t)}/permissions/${encodeURIComponent(i)}`, {
    token: a,
    method: "PUT",
    body: {
      expectedVersion: se.parse(r),
      effect: e.enum(["GRANT", "DENY", "INHERIT"]).parse(o)
    }
  }));
}
const Ur = e.object({
  membershipId: e.number().int().positive(),
  distributorId: e.number().int().positive(),
  role: e.enum(["DISTRIBUTOR_OWNER", "DISTRIBUTOR_EMPLOYEE", "CLIENT_OWNER", "CLIENT_EMPLOYEE"]),
  state: e.literal("ACTIVE"),
  clientGroupId: e.number().int().positive().nullable(),
  clientGroupName: e.string().nullable(),
  sourceManagerId: e.number().int().positive().nullable(),
  permissions: e.array(e.string()),
  version: e.number().int().nonnegative()
});
async function Ml(n, a) {
  return Ur.parse(await n.request("/portal/session", { token: a }));
}
const I = e.number().int().positive(), gt = e.object({
  id: I,
  externalId: e.string().uuid().nullable(),
  name: e.string(),
  pending: e.boolean(),
  active: e.boolean()
}), yt = gt.extend({ clientId: I, address: e.string().nullable() }), ht = e.object({
  id: I,
  clientId: I,
  name: e.string(),
  inn: e.string().nullable(),
  active: e.boolean()
}), Lr = ht.extend({ externalId: e.string().uuid().nullable(), kpp: e.string().nullable() }), ft = e.object({
  tradepoint: yt,
  groupId: I,
  groupName: e.string(),
  groupVersion: e.number().int().min(-1),
  allowedPayers: e.array(ht.extend({ pending: e.boolean() }))
}), Ae = (n) => e.object({
  content: e.array(n),
  totalPages: e.number().int().nonnegative(),
  totalElements: e.number().int().nonnegative()
});
async function _l(n, a, t, r) {
  return Ae(gt).parse(await n.request("/portal/manager/clients", { token: a, query: { search: t, page: r, size: 20 } }));
}
async function Gl(n, a, t, r, i) {
  return I.parse(t), Ae(yt).parse(await n.request(`/portal/manager/clients/${t}/tradepoints`, { token: a, query: { search: r, page: i, size: 20 } }));
}
async function zl(n, a, t) {
  return I.parse(t), ft.parse(await n.request(`/portal/manager/tradepoints/${t}/payers`, { token: a }));
}
async function Hl(n, a, t, r, i) {
  return I.parse(t), Ae(Lr).parse(await n.request(`/portal/manager/tradepoints/${t}/payers/candidates`, { token: a, query: { search: r, page: i, size: 20 } }));
}
async function Bl(n, a, t, r, i) {
  I.parse(t);
  const o = e.object({ expectedGroupVersion: e.number().int().min(-1), payerIds: e.array(I).max(500).refine((s) => new Set(s).size === s.length) }).parse({ expectedGroupVersion: r, payerIds: i });
  return ft.parse(await n.request(`/portal/manager/tradepoints/${t}/payers`, { token: a, method: "PUT", body: o }));
}
const h = e.number().int().positive().safe(), be = e.string().regex(/^-?\d+(\.\d+)?$/), Mr = e.object({
  skuId: h,
  sourceId: e.string(),
  productId: h,
  productName: e.string(),
  description: e.string().nullable(),
  slug: e.string(),
  categoryId: h.nullable(),
  name: e.string(),
  article: e.string().nullable(),
  unitCode: e.string().nullable(),
  unitName: e.string().nullable().optional(),
  unitRatio: be.nullable(),
  price: be.nullable(),
  currency: e.string().nullable(),
  availableQuantity: be.nullable(),
  stockReceivedAt: e.string().nullable(),
  stockCaptureStartedAt: e.string().datetime({ offset: !0 }).nullable().optional().default(null),
  availabilityReasons: e.array(e.object({ code: e.string(), message: e.string() })),
  canAddToCart: e.boolean()
}), It = (n) => e.object({
  content: e.array(n),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative(),
  number: e.number().int().nonnegative(),
  size: e.number().int().positive()
}), St = e.object({
  tradepointId: h,
  warehouseId: h.nullable(),
  warehouseName: e.string().nullable(),
  items: It(Mr)
}), wt = e.object({ id: h, parentId: h.nullable(), name: e.string() }), _r = It(wt), Gr = e.array(wt).min(1).max(32);
async function Vl(n, a, t, r) {
  return h.parse(t.tradepointId), St.parse(await n.request("/portal/catalog", { token: a, query: { ...t }, signal: r }));
}
async function Fl(n, a, t, r, i) {
  return h.parse(r.tradepointId), St.parse(await n.request(
    `/portal/catalog/products/${h.parse(t)}`,
    { token: a, query: r, signal: i }
  ));
}
async function Wl(n, a, t = {}, r) {
  return _r.parse(await n.request("/portal/catalog/categories", { token: a, query: t, signal: r }));
}
async function Yl(n, a, t, r) {
  return Gr.parse(await n.request(
    `/portal/catalog/categories/${h.parse(t)}/path`,
    { token: a, signal: r }
  ));
}
const A = e.number().int().positive().safe(), le = e.number().int().nonnegative().safe(), te = e.object({ tradepointId: A, payerId: A }), U = e.object({
  membership: Y.extend({ blockReason: e.string().nullable() }),
  name: e.string().nullable(),
  email: e.string().nullable(),
  assignedPairs: e.array(te),
  effectivePairs: e.array(te),
  overrides: e.array(e.object({ code: e.string(), effect: e.enum(["GRANT", "DENY"]) })),
  effectivePermissions: e.array(e.string()),
  sessionRevocationPending: e.boolean()
}), zr = e.object({
  groupVersion: e.number().int().min(-1).safe(),
  pairs: e.array(te.extend({
    tradepointName: e.string(),
    address: e.string().nullable(),
    payerName: e.string(),
    inn: e.string().nullable()
  }))
}), Hr = e.object({
  code: e.string(),
  label: e.string(),
  canGrant: e.boolean()
});
async function Kl(n, a, t = 0, r) {
  return e.object({
    content: e.array(U),
    totalElements: e.number().int().nonnegative(),
    totalPages: e.number().int().nonnegative()
  }).parse(await n.request(
    "/portal/client-employees",
    { token: a, query: { page: t, size: 20 }, signal: r }
  ));
}
async function Ql(n, a, t, r) {
  return U.parse(await n.request(`/portal/client-employees/${A.parse(t)}`, { token: a, signal: r }));
}
async function Jl(n, a, t) {
  return zr.parse(await n.request("/portal/client-employees/pair-candidates", { token: a, signal: t }));
}
async function Xl(n, a, t) {
  return e.array(Hr).parse(await n.request("/portal/client-employees/permission-catalog", { token: a, signal: t }));
}
async function Zl(n, a, t, r) {
  return U.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/block`,
    { token: a, method: "POST", body: { expectedVersion: le.parse(r) } }
  ));
}
async function ec(n, a, t, r) {
  return U.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/restore`,
    { token: a, method: "POST", body: { expectedVersion: le.parse(r), confirmed: !0 } }
  ));
}
async function tc(n, a, t, r, i, o) {
  return U.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/pairs`,
    { token: a, method: "PUT", body: {
      expectedVersion: le.parse(r),
      expectedGroupVersion: e.number().int().min(-1).safe().parse(i),
      pairs: e.array(te).max(500).parse(o)
    } }
  ));
}
async function nc(n, a, t, r, i, o) {
  return U.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/permissions/${encodeURIComponent(i)}`,
    { token: a, method: "PUT", body: {
      expectedVersion: le.parse(r),
      effect: e.enum(["GRANT", "DENY", "INHERIT"]).parse(o)
    } }
  ));
}
const b = e.number().int().positive().safe(), L = e.number().int().nonnegative().safe(), Ce = e.object({
  id: b,
  name: e.string(),
  slug: e.string().nullable(),
  published: e.boolean(),
  archived: e.boolean(),
  publicationVersion: L
}), Oe = e.object({
  id: b,
  clientId: b,
  name: e.string(),
  address: e.string().nullable(),
  active: e.boolean(),
  warehouseId: b.nullable(),
  warehouseName: e.string().nullable(),
  warehouseActive: e.boolean().nullable(),
  bindingVersion: L
}), Br = e.object({
  id: b,
  sourceExternalId: e.string().uuid(),
  name: e.string(),
  active: e.boolean(),
  sourceConnectionId: e.string().uuid().nullable(),
  sourceRunId: e.string().uuid().nullable()
}), ce = (n) => e.object({
  content: e.array(n),
  totalPages: e.number().int().nonnegative(),
  totalElements: e.number().int().nonnegative()
}), Vr = e.object({
  skuId: b,
  name: e.string(),
  article: e.string().nullable(),
  unitCode: e.string().nullable(),
  unitName: e.string().nullable(),
  price: e.string().regex(/^-?\d+(\.\d+)?$(?![\s\S])/).nullable(),
  currency: e.string().nullable(),
  availableQuantity: e.string().regex(/^-?\d+(\.\d+)?$(?![\s\S])/).nullable(),
  stockReceivedAt: e.string().nullable(),
  stockCaptureStartedAt: e.string().nullable(),
  reasons: e.array(e.object({ code: e.string(), message: e.string() }))
}), Fr = e.object({
  tradepointId: b,
  warehouseId: b.nullable(),
  warehouseName: e.string().nullable(),
  items: ce(Vr)
});
async function ac(n, a, t, r, i, o) {
  return Fr.parse(await n.request(
    `/portal/owner/catalog/products/${b.parse(t)}/availability`,
    { token: a, signal: o, query: {
      tradepointId: b.parse(r),
      page: L.parse(i),
      size: 20
    } }
  ));
}
const Re = (n, a) => ({
  q: e.string().max(160).parse(n),
  page: L.parse(a),
  size: 20
});
async function rc(n, a, t, r) {
  return ce(Ce).parse(await n.request("/portal/owner/catalog/products", { token: a, query: Re(t, r) }));
}
async function ic(n, a, t) {
  return Ce.parse(await n.request(`/portal/owner/catalog/products/${b.parse(t)}`, { token: a }));
}
async function oc(n, a, t, r, i) {
  return Ce.parse(await n.request(
    `/portal/owner/catalog/products/${b.parse(t)}/publication`,
    { token: a, method: "PUT", body: { expectedVersion: L.parse(r), published: e.boolean().parse(i) } }
  ));
}
async function sc(n, a, t, r, i) {
  return ce(Oe).parse(await n.request("/portal/owner/tradepoints", { token: a, signal: i, query: Re(t, r) }));
}
async function lc(n, a, t) {
  return Oe.parse(await n.request(`/portal/owner/tradepoints/${b.parse(t)}`, { token: a }));
}
async function cc(n, a, t, r) {
  return ce(Br).parse(await n.request("/portal/owner/warehouses", { token: a, query: Re(t, r) }));
}
async function uc(n, a, t, r, i) {
  return Oe.parse(await n.request(
    `/portal/owner/tradepoints/${b.parse(t)}/warehouse`,
    { token: a, method: "PUT", body: { expectedVersion: L.parse(r), warehouseId: b.nullable().parse(i) } }
  ));
}
const M = e.string().uuid(), je = "/portal/distributor-owner-invitations", vt = e.object({ equalRightsAndFullVisibilityConfirmed: e.literal(!0) }).strict(), qe = e.object({
  id: M,
  email: e.string(),
  name: e.string(),
  role: e.literal("DISTRIBUTOR_OWNER"),
  accessScope: e.literal("ALL_DISTRIBUTOR"),
  disclosureVersion: e.literal("owner-equal-access/v1"),
  permissions: e.array(e.string()),
  state: e.enum(["PENDING", "ACCEPTED", "REVOKED", "EXPIRED"]),
  expiresAt: e.string().datetime({ offset: !0 }),
  acceptedAt: e.string().datetime({ offset: !0 }).nullable()
}), Wr = e.object({
  invitation: qe,
  distributorName: e.string().nullable(),
  distributorSubdomain: e.string()
}), Yr = vt.extend({
  requestId: M,
  email: e.string().trim().email().max(254),
  name: e.string().trim().min(1).max(200)
}).strict(), Kr = Y.extend({
  role: e.literal("DISTRIBUTOR_OWNER"),
  clientGroupId: e.null(),
  sourceManagerId: e.null()
});
async function dc(n, a, t) {
  return e.object({ invitation: qe, token: M }).parse(
    await n.request(je, {
      token: a,
      method: "POST",
      body: Yr.parse(t),
      cache: "no-store"
    })
  );
}
async function mc(n, a, t) {
  return e.array(qe).parse(await n.request(
    je,
    { token: a, signal: t, cache: "no-store" }
  ));
}
async function bc(n, a, t) {
  await n.request(`${je}/${M.parse(t)}`, { token: a, method: "DELETE", cache: "no-store" });
}
async function pc(n, a, t) {
  return Wr.parse(await n.request(
    De(a),
    { signal: t, cache: "no-store", referrerPolicy: "no-referrer" }
  ));
}
async function gc(n, a, t, r) {
  const i = e.object({ password: e.string().min(8).max(128), consent: e.literal(!0) }).parse({ password: t, consent: r });
  return e.object({ status: e.enum(["LOGIN_REQUIRED", "LOGIN_EXISTING_ACCOUNT"]) }).parse(
    await n.request(
      `${De(a)}/register`,
      { method: "POST", body: i, cache: "no-store", referrerPolicy: "no-referrer" }
    )
  );
}
async function yc(n, a, t, r) {
  const i = vt.parse({ equalRightsAndFullVisibilityConfirmed: r });
  return Kr.parse(await n.request(
    `${De(t)}/accept`,
    { token: a, method: "POST", body: i, cache: "no-store", referrerPolicy: "no-referrer" }
  ));
}
function hc(n, a) {
  const t = new URL("/owner-invite", n);
  if (!["https:", "http:"].includes(t.protocol)) throw new Error("Нужен HTTP(S) адрес портала");
  return t.hash = M.parse(a), t.toString();
}
function De(n) {
  return `/invitations/by-token/${M.parse(n)}/owner`;
}
const ue = e.object({ connectionId: e.string().uuid(), runId: e.string().uuid() }), Et = e.object({
  registered: e.boolean(),
  connectionId: e.string().uuid().nullable(),
  generation: e.number().int().positive().nullable(),
  registeredAt: e.string().datetime({ offset: !0 }).nullable()
}), p = e.number().int().nonnegative().safe(), Pt = ue.extend({
  processed: p,
  applied: p,
  replayed: p,
  stale: p,
  quarantined: p,
  issues: e.object({ content: e.array(e.object({
    sourceObjectId: e.number().int().positive().safe(),
    sourceOrderId: e.string().uuid().nullable(),
    status: e.literal("QUARANTINED"),
    reason: e.string()
  })), totalElements: p, totalPages: p })
}), Qr = e.enum([
  "QUEUED",
  "CLAIMED",
  "DISCOVERING",
  "EXPORTING",
  "COMPLETED",
  "COMPLETED_WITH_ERRORS",
  "FAILED",
  "CANCELLED"
]), $e = e.object({
  id: e.string().uuid(),
  connectionId: e.string().uuid(),
  clientId: e.number().int().positive(),
  tradePointId: e.number().int().positive(),
  year: e.number().int().min(2e3).max(2100),
  dateFrom: e.string(),
  dateTo: e.string(),
  sourceZone: e.string(),
  status: Qr,
  discoveredCount: p.nullable(),
  appliedCount: p,
  quarantinedCount: p,
  lastErrorCode: e.string().nullable(),
  lastHeartbeatAt: e.string().datetime({ offset: !0 }).nullable(),
  terminalAt: e.string().datetime({ offset: !0 }).nullable(),
  createdAt: e.string().datetime({ offset: !0 }),
  updatedAt: e.string().datetime({ offset: !0 }).nullable()
}), Jr = e.object({
  content: e.array($e),
  totalElements: p,
  totalPages: p,
  number: p,
  size: p
}), Xr = e.object({
  creationEnabled: e.boolean(),
  claimEnabled: e.boolean()
}), Zr = e.object({
  id: e.number().int().positive(),
  clientId: e.number().int().positive(),
  name: e.string(),
  active: e.boolean()
});
async function fc(n, a, t) {
  return Xr.parse(await n.request(
    "/portal/order-history/jobs/capabilities",
    { token: a, signal: t }
  ));
}
async function Ic(n, a, t, r) {
  const i = e.object({
    connectionId: e.string().uuid(),
    clientId: e.number().int().positive()
  }).parse(t);
  return e.array(Zr).parse(await n.request(
    "/portal/order-history/jobs/tradepoints",
    { token: a, query: i, signal: r }
  ));
}
async function Sc(n, a, t) {
  return $e.parse(await n.request("/portal/order-history/jobs", {
    token: a,
    method: "POST",
    body: e.object({
      connectionId: e.string().uuid(),
      tradePointId: e.number().int().positive(),
      year: e.number().int().min(2e3).max(2100)
    }).parse(t)
  }));
}
async function wc(n, a, t = {}, r) {
  return Jr.parse(await n.request("/portal/order-history/jobs", {
    token: a,
    query: {
      ...t,
      page: t.page ?? 0,
      size: t.size ?? 20,
      sort: "createdAt,desc"
    },
    signal: r
  }));
}
async function vc(n, a, t) {
  const r = e.string().uuid().parse(t);
  return $e.parse(await n.request(`/portal/order-history/jobs/${r}/cancel`, {
    token: a,
    method: "POST"
  }));
}
async function Ec(n, a, t) {
  return Et.parse(await n.request("/portal/order-history/registration", { token: a, signal: t }));
}
async function Pc(n, a, t) {
  return Et.parse(await n.request(
    "/portal/order-history/registration",
    { token: a, method: "POST", body: ue.parse(t) }
  ));
}
async function Tc(n, a, t) {
  return Pt.parse(await n.request(
    "/portal/order-history/project",
    { token: a, method: "POST", body: ue.parse(t) }
  ));
}
async function Ac(n, a, t, r = 0, i) {
  return Pt.parse(await n.request(
    "/portal/order-history/report",
    { token: a, query: { ...ue.parse(t), page: r, size: 20 }, signal: i }
  ));
}
const P = e.string().uuid(), z = e.string().datetime({ offset: !0 }).nullable(), ei = e.object({
  connectionId: P,
  runId: P,
  state: e.string(),
  reason: e.string().nullable(),
  createdAt: z,
  completedAt: z,
  captureStartedAt: z,
  automaticModeEnabled: e.boolean(),
  automaticModeConnectionId: P.nullable(),
  automaticModeActivatedAt: z,
  lastAppliedConnectionId: P.nullable(),
  lastAppliedRunId: P.nullable(),
  lastAppliedAt: z,
  historyState: e.string().nullable().optional().default(null),
  historyProcessed: e.number().int().nonnegative().safe().nullable().optional().default(null),
  historyQuarantined: e.number().int().nonnegative().safe().nullable().optional().default(null)
});
async function Cc(n, a, t, r) {
  const i = P.parse(t.connectionId), o = P.parse(t.runId);
  return ei.parse(await n.request(
    `/portal/source-runs/${i}/${o}/projection`,
    { token: a, signal: r }
  ));
}
const H = e.number().int().positive().safe(), B = e.string().uuid(), Tt = e.enum(["PENDING", "ACTIVE", "BLOCKED"]), ti = e.object({
  distributorId: H,
  primaryOwner: e.object({ subject: B, name: e.string().nullable(), email: e.string().nullable() }).nullable(),
  membership: e.object({ id: H, role: e.string(), state: Tt }).nullable(),
  canProvision: e.boolean(),
  reason: e.string().nullable()
}), ni = e.object({
  requestId: B,
  ownerSubject: B,
  equalRightsAndFullVisibilityConfirmed: e.literal(!0)
}).strict(), ai = e.object({
  distributorId: H,
  subject: B,
  membershipId: H,
  role: e.literal("DISTRIBUTOR_OWNER"),
  state: Tt,
  requestId: B,
  grantedAt: e.string().datetime({ offset: !0 }),
  replayed: e.boolean()
}), At = (n) => `/admin/platform/distributors/${H.parse(n)}/owner-access`;
async function Oc(n, a, t, r) {
  return ti.parse(await n.request(At(t), { token: a, signal: r, cache: "no-store" }));
}
async function Rc(n, a, t, r) {
  return ai.parse(await n.request(At(t), {
    token: a,
    method: "POST",
    body: ni.parse(r),
    cache: "no-store"
  }));
}
const Ne = oe.extend({
  canConfirm: e.boolean(),
  clientGroupId: e.number().int().positive().nullable(),
  rows: e.array(e.object({
    kind: e.enum(["CLIENT", "TRADEPOINT", "PAYER"]),
    sourceExternalId: e.string().uuid(),
    sourceName: e.string(),
    action: e.enum(["CREATE", "REUSE", "BLOCKED"]),
    existingId: e.number().int().positive().nullable(),
    existingName: e.string().nullable(),
    existingClientId: e.number().int().positive().nullable(),
    reason: e.string().nullable(),
    sourceAddress: e.string().nullable().optional().default(null),
    existingAddress: e.string().nullable().optional().default(null),
    sourceInn: e.string().nullable().optional().default(null),
    existingInn: e.string().nullable().optional().default(null),
    sourceKpp: e.string().nullable().optional().default(null),
    existingKpp: e.string().nullable().optional().default(null),
    sourceFields: e.array(e.string()).optional().default([])
  }))
}), xe = "/portal/mapping/reconciliations";
async function jc(n, a, t) {
  return Ne.parse(await n.request(xe, { token: a, method: "POST", body: t }));
}
async function qc(n, a, t) {
  return Ne.parse(await n.request(`${xe}/${e.string().uuid().parse(t)}`, { token: a }));
}
async function Dc(n, a, t, r) {
  if (!r) throw new Error("Нужно явное согласие на использование существующих записей");
  return Ne.parse(await n.request(`${xe}/${e.string().uuid().parse(t.id)}/confirm`, {
    token: a,
    method: "POST",
    body: { expectedVersion: t.version, existingRecordsReuseConfirmed: !0 }
  }));
}
const C = e.string().uuid(), Ct = e.object({
  requestId: C,
  connectionId: C,
  generation: e.literal(1),
  adapterId: e.string().min(1),
  artifactSha256: e.string().regex(/^[0-9a-f]{64}$/),
  platformVersion: e.string().min(1),
  configurationVersion: e.string().min(1),
  eventSchema: e.literal("ds2b_event/v1"),
  capabilities: e.array(e.string()),
  runtimeCases: e.record(e.literal("PASS")),
  executedAt: e.string().datetime({ offset: !0 }),
  reportText: e.string().min(100).max(65536).refine(
    (n) => new TextEncoder().encode(n).byteLength <= 65536,
    "Отчёт превышает 64 КиБ UTF-8"
  )
}), ke = Ct.omit({ requestId: !0, reportText: !0 }).extend({
  id: C,
  reportSha256: e.string().regex(/^[0-9a-f]{64}$/),
  recordedAt: e.string(),
  recordedBy: C,
  backendContractId: e.string()
}), Ue = e.object({
  version: e.number().int().nonnegative(),
  state: e.enum(["UNAPPROVED", "APPROVED", "REVOKED", "INVALIDATED"]),
  evidence: ke.nullable(),
  approvedAt: e.string().nullable(),
  approvedBy: C.nullable(),
  revokedReason: e.string().nullable(),
  humanAttested: e.boolean(),
  requiredRuntimeCases: e.array(e.string()),
  requiredCapabilities: e.array(e.string())
}), _ = (n) => `/admin/platform/distributors/${e.number().int().positive().parse(n)}/adapter-admissions`;
async function $c(n, a, t) {
  return Ue.parse(await n.request(_(t), { token: a }));
}
async function Nc(n, a, t) {
  return e.array(ke).parse(await n.request(`${_(t)}/evidence`, { token: a }));
}
async function xc(n, a, t, r) {
  return e.string().parse(await n.request(`${_(t)}/evidence/${C.parse(r)}/report`, { token: a }));
}
async function kc(n, a, t, r) {
  return ke.parse(await n.request(`${_(t)}/evidence`, {
    token: a,
    method: "POST",
    body: Ct.parse(r)
  }));
}
async function Uc(n, a, t, r, i) {
  if (!i.reviewConfirmed) throw new Error("Нужно явно подтвердить проверку отчёта");
  return Ue.parse(await n.request(`${_(t)}/${C.parse(r)}/approve`, {
    token: a,
    method: "POST",
    body: i
  }));
}
async function Lc(n, a, t, r) {
  return Ue.parse(await n.request(`${_(t)}/revoke`, { token: a, method: "POST", body: r }));
}
const $ = e.number().int().positive().safe(), Ot = e.number().int().nonnegative().safe(), T = e.string().regex(/^-?\d+(?:\.\d+)?$/), Rt = e.object({
  connectionId: e.string().uuid(),
  runId: e.string().uuid(),
  sourceOrderId: e.string().uuid()
}).strict(), Be = e.object({
  documentNumber: e.string().nullable(),
  documentDate: e.string().datetime({ offset: !0 }).nullable(),
  statusCode: e.string(),
  statusName: e.string().nullable(),
  totalAmount: T,
  currency: e.string(),
  deliveryAddress: e.string().nullable(),
  clientId: $.nullable(),
  tradepointId: $.nullable(),
  payerId: $.nullable(),
  clientName: e.string().nullable(),
  tradepointName: e.string().nullable(),
  payerName: e.string().nullable(),
  lineCount: e.number().int().nonnegative().safe()
}), Ve = e.object({
  lineNumber: $,
  skuExternalId: e.string().nullable(),
  name: e.string().nullable(),
  quantity: T.nullable(),
  unitCode: e.string().nullable(),
  price: T.nullable(),
  total: T.nullable()
}), Le = Rt.extend({
  id: e.string().uuid(),
  generation: $,
  revision: e.string().regex(/^[1-9]\d*$/),
  version: Ot,
  orderId: $.nullable(),
  current: Be.nullable(),
  incoming: Be,
  currentLines: e.array(Ve),
  incomingLines: e.array(Ve.extend({ quantity: T, price: T, total: T })),
  canConfirm: e.boolean(),
  reason: e.string().nullable(),
  createdAt: e.string().datetime({ offset: !0 }),
  confirmedAt: e.string().datetime({ offset: !0 }).nullable()
}), Me = "/portal/order-history/adoptions";
async function Mc(n, a, t) {
  return Le.parse(await n.request(Me, { token: a, method: "POST", body: Rt.parse(t) }));
}
async function _c(n, a, t, r) {
  return Le.parse(await n.request(`${Me}/${e.string().uuid().parse(t)}`, { token: a, signal: r }));
}
async function Gc(n, a, t, r) {
  if (!r) throw new Error("Подтвердите применение снимка к существующему заказу");
  return Le.parse(await n.request(`${Me}/${e.string().uuid().parse(t.id)}/confirm`, {
    token: a,
    method: "POST",
    body: { expectedVersion: Ot.parse(t.version), sourceSnapshotAdoptionConfirmed: !0 }
  }));
}
const ri = e.object({
  displayName: e.string().nullable(),
  phone: e.string().nullable(),
  email: e.string().nullable(),
  officeAddress: e.string().nullable()
}).strict();
async function zc(n, a, t) {
  return ri.parse(await n.request("/portal/distributor-contacts", { token: a, signal: t }));
}
const K = e.number().int().positive().safe(), O = e.string().uuid().refine((n) => n !== "00000000-0000-0000-0000-000000000000"), R = e.string().regex(/^[1-9][0-9]{0,18}$/).refine((n) => !/\s/.test(n) && BigInt(n) <= 9223372036854775807n), ii = e.enum([
  "access_revoked",
  "permission_revoked",
  "policy_closed",
  "adapter_unverified",
  "dossier_changed",
  "source_changed",
  "window_closed",
  "source_snapshot_missing",
  "mutation_pending"
]), jt = e.object({
  mutationId: O,
  baseRevision: R,
  state: e.enum(["PENDING", "AWAITING_SNAPSHOT", "CLOSED"]),
  outcome: e.enum(["APPLIED", "REJECTED", "CONFLICT"]).nullable(),
  resultRevision: R.nullable(),
  errorCode: e.string().nullable(),
  localResolution: e.literal("LOCAL_NOT_DISPATCHED").nullable(),
  localReason: e.string().nullable(),
  deliveryDiagnostic: e.string().nullable()
}).strict(), oi = e.object({ availability: e.object({
  allowed: e.boolean(),
  reasons: e.array(ii),
  baseRevision: R.nullable()
}).strict().refine((n) => n.allowed ? n.reasons.length === 0 && n.baseRevision !== null : n.reasons.length > 0), latest: jt.nullable() }).strict(), si = e.object({
  quoteId: O,
  orderId: K,
  baseRevision: R,
  policyVersion: e.number().int().nonnegative().safe(),
  expiresAt: e.string().datetime({ offset: !0 })
}).strict(), li = e.object({
  quoteId: O,
  mutationId: O,
  baseRevision: R
}).strict(), ci = e.object({
  quoteId: O,
  idempotencyKey: O,
  baseRevision: R
}).strict();
async function Hc(n, a, t, r) {
  return oi.parse(await n.request(
    `/portal/orders/${K.parse(t)}/cancellation-context`,
    { token: a, signal: r, cache: "no-store" }
  ));
}
async function Bc(n, a, t, r) {
  return si.parse(await n.request(
    `/portal/orders/${K.parse(t)}/cancellation-quotes`,
    { token: a, method: "POST", body: { baseRevision: R.parse(r) } }
  ));
}
async function Vc(n, a, t, r) {
  const i = ci.parse(r);
  return li.parse(await n.request(
    `/portal/orders/${K.parse(t)}/cancellations`,
    { token: a, method: "POST", body: { quoteId: i.quoteId, idempotencyKey: i.idempotencyKey } }
  ));
}
async function Fc(n, a, t, r, i) {
  return jt.parse(await n.request(
    `/portal/orders/${K.parse(t)}/cancellations/${O.parse(r)}`,
    { token: a, signal: i, cache: "no-store" }
  ));
}
export {
  Vt as AcceptInvitationRequestSchema,
  aa as ActivityItemSchema,
  na as ActivityKindSchema,
  Ue as AdapterAdmissionSchema,
  Ct as AdapterEvidenceInputSchema,
  ke as AdapterEvidenceSchema,
  yi as AddToCartRequestSchema,
  mn as AddTradepointsRequestSchema,
  nt as AdminClientListItemSchema,
  Ea as AdminClientPageSchema,
  Bn as AdminExchangeTestOrderRequestSchema,
  Vn as AdminExchangeTestOrderResponseSchema,
  x as ApiError,
  Da as ApplyPhotosResultSchema,
  Wt as AssignWarehouseRequestSchema,
  Wn as BulkOrderActionRequestSchema,
  Kn as BulkOrderActionResponseSchema,
  Fn as BulkOrderActionSchema,
  Yn as BulkOrderFailureSchema,
  ci as CancellationAttemptSchema,
  oi as CancellationContextSchema,
  si as CancellationQuoteSchema,
  ii as CancellationReasonSchema,
  li as CancellationReceiptSchema,
  jt as CancellationStatusSchema,
  ya as CartLineDetailSchema,
  gi as CartSnapshotSchema,
  rt as CatalogPhotoResponseSchema,
  ja as CatalogProductAdminListItemSchema,
  qa as CatalogProductAdminPageSchema,
  Ze as CategoryNodeSchema,
  Lt as ChangeEmailRequestSchema,
  Mt as ChangePasswordRequestSchema,
  Ga as CheckSlugResponseSchema,
  Xn as ClientAgreementListItemSchema,
  la as ClientContactPatchSchema,
  ia as ClientContactsPatchSchema,
  zr as ClientEmployeePairCandidatesSchema,
  Hr as ClientEmployeePermissionSchema,
  U as ClientEmployeeSchema,
  Sr as ClientGroupAccessReadinessSchema,
  lt as ClientGroupSchema,
  bn as ClientLookupItemSchema,
  Ft as ClientTradepointItemSchema,
  pt as CommercialPreviewSchema,
  Ha as CreateDistributorRequestSchema,
  Va as CreateDistributorResponseSchema,
  zt as CreateInvitationRequestSchema,
  Ht as CreateInvitationResponseSchema,
  un as CreateTerritoryRequestSchema,
  ra as DashboardActivitySchema,
  ta as DashboardSummarySchema,
  ir as DistributorAuditEventPageSchema,
  st as DistributorAuditEventSchema,
  er as DistributorClientHitSchema,
  ri as DistributorContactsSchema,
  fe as DistributorDetailSchema,
  Ua as DistributorListItemSchema,
  La as DistributorListPageSchema,
  Zn as DistributorManagerListItemSchema,
  Za as DistributorOrderHitSchema,
  _a as DistributorOwnerSchema,
  rn as DistributorPriceTypeOptionSchema,
  tn as DistributorPublicInfoSchema,
  ge as DistributorRoleSchema,
  ar as DistributorSearchResponseSchema,
  V as DistributorSettingsSchema,
  an as DistributorSettingsUpdateSchema,
  nr as DistributorSkuHitSchema,
  W as DistributorStatusSchema,
  tr as DistributorTradepointHitSchema,
  F as DistributorUserDetailSchema,
  et as DistributorUserListItemSchema,
  Qn as DraftAgreementCreateRequestSchema,
  Jn as DraftAgreementDetailSchema,
  Cr as EmployeeInvitationPreviewSchema,
  Ee as EmployeeInvitationSchema,
  kr as EmployeePermissionSchema,
  k as EmployeeSchema,
  Jt as ExchangeCredentialsListItemSchema,
  Xt as ExchangeCredentialsListSchema,
  D as GroupInvitationAttemptError,
  Pr as GroupInvitationPreviewSchema,
  we as GroupInvitationSchema,
  Y as GroupMembershipSchema,
  nn as HexColorSchema,
  Xr as HistoryJobCapabilitiesSchema,
  Jr as HistoryJobPageSchema,
  $e as HistoryJobSchema,
  Qr as HistoryJobStatusSchema,
  Et as HistoryRegistrationSchema,
  Pt as HistoryReportSchema,
  Zr as HistoryTradePointSchema,
  Qt as Integration1cHealthSchema,
  Kt as Integration1cStatusSchema,
  _t as InvitationDtoSchema,
  va as InvitationInfoSchema,
  ne as InvitationKindSchema,
  Bt as InvitationPreviewSchema,
  bi as InvitationRoleSchema,
  Ke as InvitationStateSchema,
  pi as InvitationStatusSchema,
  Ln as InviteDistributorUserRequestSchema,
  Mn as InviteDistributorUserResponseSchema,
  Qe as IssuedExchangeCredentialsSchema,
  sa as LegalEntityContactsPatchSchema,
  xr as ManagerProjectionSchema,
  Ra as ManualLinkRequestSchema,
  ct as MappedClientSchema,
  gr as MappingClientGroupPageSchema,
  oe as MappingPreviewSchema,
  Ne as MappingReconciliationSchema,
  mr as MappingTargetGroupSchema,
  dr as MarkAllReadResponseSchema,
  Ta as MatchCandidateSchema,
  Aa as MatchCandidatesPayloadSchema,
  kt as MePatchSchema,
  Ut as MeProfilePatchSchema,
  Ye as MeProfileSchema,
  We as MeSchema,
  En as MyAgreementListItemSchema,
  Pn as MyAgreementPageSchema,
  ma as MyClientContactResponseSchema,
  ca as MyClientResponseSchema,
  Xe as MyContextSchema,
  wn as MyLegalEntityListItemSchema,
  vn as MyLegalEntityPageSchema,
  da as MyLegalEntityResponseSchema,
  Tn as MyPersonalPriceListItemSchema,
  An as MyPersonalPricePageSchema,
  In as MyTradePointListItemSchema,
  Sn as MyTradePointPageSchema,
  ua as MyTradePointResponseSchema,
  lr as NotificationItemSchema,
  sr as NotificationKindSchema,
  cr as NotificationPageSchema,
  Ma as OnboardingChecklistSchema,
  ea as OnboardingProgressSchema,
  pa as OnboardingStateSchema,
  ba as OnboardingStepSchema,
  Le as OrderAdoptionSchema,
  Rt as OrderAdoptionSelectionSchema,
  Nn as OrderAttachmentInfoSchema,
  Hn as OrderCancelRequestSchema,
  $r as OrderCommandStatusSchema,
  re as OrderDetailSchema,
  xn as OrderEditEventDetailSchema,
  Gn as OrderEditLineRequestSchema,
  zn as OrderEditRequestSchema,
  Dn as OrderLineDetailSchema,
  hn as OrderListItemSchema,
  Dr as OrderMutationPolicySchema,
  jr as OrderOperationAvailabilitySchema,
  fn as OrderPageSchema,
  ee as OrderPolicySchema,
  Un as OrderRepeatResultSchema,
  $n as OrderStatusEventDetailSchema,
  Wr as OwnerInvitationPreviewSchema,
  qe as OwnerInvitationSchema,
  u as PageSchema,
  Ca as PendingOrderListItemSchema,
  Oa as PendingOrderPageSchema,
  at as PhotoUploadResponseSchema,
  rr as PlatformAuditLogListItemSchema,
  ot as PlatformAuditLogPageSchema,
  or as PlatformDistributorUserListItemSchema,
  Qa as PlatformSearchDistributorHitSchema,
  Ja as PlatformSearchOrderHitSchema,
  Xa as PlatformSearchResponseSchema,
  Sa as PortalAccessSchema,
  he as PortalCartSnapshotSchema,
  _r as PortalCatalogCategoriesSchema,
  Gr as PortalCatalogCategoryPathSchema,
  Mr as PortalCatalogItemSchema,
  St as PortalCatalogPageSchema,
  qr as PortalOrderDetailSchema,
  bt as PortalOrderSchema,
  Ur as PortalSessionSchema,
  ti as PrimaryOwnerAccessSchema,
  ai as PrimaryOwnerReceiptSchema,
  qn as ProductCardDetailSchema,
  jn as ProductCardSkuSchema,
  Rn as ProductCardStockSchema,
  ni as ProvisionPrimaryOwnerSchema,
  Wa as ReassignOwnerRequestSchema,
  Ya as ReassignOwnerResponseSchema,
  kn as RepeatSkippedLineSchema,
  Fa as ResendInviteResponseSchema,
  Cn as SkuSearchItemSchema,
  On as SkuSearchPageSchema,
  on as SliceSchema,
  Te as SourceManagerCandidateSchema,
  Nr as SourceOrderAssetSchema,
  ei as SourceProjectionSchema,
  fr as SourceRunPageSchema,
  Ir as SourceRunStatusSchema,
  hr as SourceRunSummarySchema,
  en as SyncEventDetailSchema,
  Zt as SyncEventListItemSchema,
  Je as SyncEventResponseStatusSchema,
  ga as SyncStateSummarySchema,
  cn as TerritoryAssignedUserSchema,
  ae as TerritoryDetailSchema,
  sn as TerritoryListItemSchema,
  ln as TerritoryTradepointBriefSchema,
  Fe as ThemePreferenceSchema,
  pn as TradePointAdminListItemSchema,
  gn as TradePointBriefSchema,
  oa as TradePointContactsPatchSchema,
  Gt as TradepointWarehouseAssignmentSchema,
  ur as UnreadCountResponseSchema,
  hi as UpdateCartLineRequestSchema,
  yn as UpdateContextRequestSchema,
  _n as UpdateDistributorUserRequestSchema,
  Ka as UpdateStatusRequestSchema,
  dn as UpdateTerritoryRequestSchema,
  Yt as WarehouseListItemSchema,
  gl as acceptEmployeeInvitation,
  ol as acceptGroupInvitation,
  Ci as acceptInvitation,
  yc as acceptOwnerInvitation,
  wo as acceptPublicInvitation,
  Ki as acknowledgeOrderChange,
  Lo as activateDistributorUser,
  no as addCartLine,
  Gi as addTerritoryTradepoints,
  cs as applyCategoryPhotosToProducts,
  Ol as applyCommercialSource,
  Uc as approveAdapterEvidence,
  hs as archiveDistributor,
  ll as beginGroupInvitationAttempt,
  Zl as blockClientEmployee,
  xl as blockEmployee,
  Ho as bulkOrderAction,
  zo as cancelAdminOrder,
  vc as cancelHistoryJob,
  Ei as changeEmail,
  Si as changePassword,
  ps as checkSlug,
  io as clearCart,
  _s as completeOnboarding,
  Vc as confirmCancellation,
  Fs as confirmMappingPreview,
  Dc as confirmMappingReconciliation,
  Gc as confirmOrderAdoption,
  lo as confirmPortalQuote,
  oo as createAdminExchangeTestOrder,
  mi as createApiClient,
  Xs as createClientGroup,
  gs as createDistributor,
  Ts as createDraftAgreement,
  Sc as createHistoryJob,
  Pi as createInvitation,
  Vs as createMappingPreview,
  jc as createMappingReconciliation,
  Mc as createOrderAdoption,
  Li as createTerritory,
  Uo as deactivateDistributorUser,
  ro as deleteCartLine,
  ls as deleteCategoryPhoto,
  fs as deleteDistributor,
  go as deleteDistributorLogo,
  os as deleteProductPhoto,
  _i as deleteTerritory,
  Qi as downloadOrderAttachment,
  Al as downloadPortalOrderFile,
  Sl as downloadSourceOrderAsset,
  yl as employeeInvitationLink,
  Do as exportMyPersonalPricesCsv,
  Fi as exportOrdersCsv,
  rs as fetchCatalogPhotoBlobUrl,
  ho as fetchDistributorLogoBlobUrl,
  cl as finishGroupInvitationAttempt,
  $c as getAdapterAdmission,
  xc as getAdapterEvidenceReport,
  Ko as getAdminClient,
  Hc as getCancellationContext,
  Fc as getCancellationStatus,
  to as getCart,
  ts as getCatalogAdminProducts,
  Zi as getCatalogProductDetail,
  as as getCategoryPhotos,
  Ql as getClientEmployee,
  el as getClientGroupAccessReadiness,
  uo as getDashboardActivity,
  co as getDashboardSummary,
  bs as getDistributor,
  js as getDistributorAuditEvent,
  zc as getDistributorContacts,
  mo as getDistributorSettings,
  No as getDistributorUser,
  Dl as getEmployee,
  Zs as getGroupClients,
  fc as getHistoryJobCapabilities,
  Ec as getHistoryRegistration,
  ji as getIntegration1cHealth,
  Ai as getInvitationByToken,
  zl as getManagerPointPayers,
  Ws as getMappingPreview,
  qc as getMappingReconciliation,
  fi as getMe,
  wi as getMeProfile,
  vo as getMyContext,
  Ls as getNotificationsUnreadCount,
  Ms as getOnboardingState,
  _c as getOrderAdoption,
  fl as getOrderCommandStatus,
  Wi as getOrderDetail,
  Ac as getOrderHistoryReport,
  hl as getOrderOperationAvailability,
  El as getOrderPolicy,
  ac as getOwnerCatalogAvailability,
  lc as getOwnerCatalogPoint,
  ic as getOwnerCatalogProduct,
  Ns as getPlatformDistributorSettings,
  eo as getPortalAccess,
  Yl as getPortalCatalogCategoryPath,
  Fl as getPortalCatalogProduct,
  vl as getPortalOrder,
  Ml as getPortalSession,
  Oc as getPrimaryOwnerAccess,
  ns as getProductPhotos,
  fo as getPublicDistributorInfo,
  So as getPublicInvitation,
  Cc as getSourceProjection,
  Ks as getSourceRunStatus,
  xi as getSyncEvent,
  zs as getSyncStateSummary,
  Ui as getTerritory,
  vs as globalSearch,
  sl as groupInvitationLink,
  Mo as hardDeleteDistributorUser,
  Cl as inspectCommercialSource,
  xo as inviteDistributorUser,
  ws as isValidInn,
  ul as issueEmployeeInvitation,
  tl as issueGroupInvitation,
  Di as issueMyExchangeCredentials,
  dc as issueOwnerInvitation,
  qs as issuePlatformExchangeCredentials,
  es as linkPendingOrder,
  Nc as listAdapterEvidence,
  Ps as listAdminAgreements,
  Bo as listAdminClients,
  Bi as listAdminClientsLookup,
  As as listAdminManagers,
  Hi as listAdminTradepoints,
  Xo as listAdminWarehouses,
  Xi as listCatalogCategories,
  Jl as listClientEmployeePairs,
  Xl as listClientEmployeePermissions,
  Kl as listClientEmployees,
  Qs as listClientGroups,
  Qo as listClientTradepoints,
  Rs as listDistributorAuditEvents,
  Os as listDistributorAuditLog,
  yo as listDistributorPriceTypes,
  $o as listDistributorUsers,
  ms as listDistributors,
  dl as listEmployeeInvitations,
  $l as listEmployeePermissions,
  Nl as listEmployeeSourceManagers,
  ql as listEmployees,
  Js as listGroupCandidates,
  nl as listGroupInvitations,
  wc as listHistoryJobs,
  Ic as listHistoryTradepoints,
  Ti as listInvitations,
  _l as listManagerClients,
  Hl as listManagerPayerCandidates,
  Gl as listManagerPoints,
  Hs as listMappingClientGroups,
  Bs as listMappingSources,
  jo as listMyAgreements,
  qi as listMyExchangeCredentials,
  Ro as listMyPayers,
  qo as listMyPersonalPrices,
  Oo as listMyTradepoints,
  xs as listNotifications,
  Vi as listOrders,
  sc as listOwnerCatalogPoints,
  rc as listOwnerCatalogProducts,
  cc as listOwnerCatalogWarehouses,
  mc as listOwnerInvitations,
  Zo as listPendingOrders,
  Cs as listPlatformAuditLog,
  $s as listPlatformDistributorUsers,
  Vl as listPortalCatalog,
  Wl as listPortalCatalogCategories,
  wl as listPortalOrders,
  jl as listSourceManagers,
  Il as listSourceOrderAssets,
  Ys as listSourceRuns,
  Ni as listSyncEvents,
  ki as listTerritories,
  Us as markAllNotificationsRead,
  Gs as markCredentialsDelivered,
  ks as markNotificationRead,
  fa as orderAttachmentDownloadUrl,
  hc as ownerInvitationLink,
  _o as patchAdminOrder,
  Co as patchClientContact,
  Po as patchClientContacts,
  bo as patchDistributorSettings,
  Ao as patchLegalEntityContacts,
  Ii as patchMe,
  vi as patchMeProfile,
  Eo as patchMyContext,
  To as patchTradePointContacts,
  Ri as postLogout,
  Bc as prepareCancellation,
  so as preparePortalQuote,
  bl as previewEmployeeInvitation,
  rl as previewGroupInvitation,
  pc as previewOwnerInvitation,
  Tc as projectOrderHistory,
  Rl as projectSourceManagers,
  Rc as provisionPrimaryOwnerAccess,
  Io as publicDistributorLogoUrl,
  Ss as reassignOwner,
  Ul as rebindEmployee,
  kc as recordAdapterEvidence,
  pl as registerEmployeeInvitation,
  il as registerGroupInvitation,
  Pc as registerHistorySource,
  gc as registerOwnerInvitation,
  zi as removeTerritoryTradepoint,
  Yi as repeatOrder,
  tc as replaceClientEmployeePairs,
  Bl as replaceManagerPointPayers,
  Go as repriceAdminOrder,
  ys as resendInvite,
  Vo as resetClientOverlay,
  Yo as resetContactOverlay,
  Wo as resetLegalEntityOverlay,
  Fo as resetTradepointOverlay,
  ec as restoreClientEmployee,
  kl as restoreEmployee,
  Lc as revokeAdapterAdmission,
  ml as revokeEmployeeInvitation,
  $i as revokeExchangeCredentials,
  al as revokeGroupInvitation,
  Oi as revokeInvitation,
  bc as revokeOwnerInvitation,
  Ds as revokePlatformExchangeCredentials,
  Ji as searchCatalogSku,
  Es as searchDistributor,
  nc as setClientEmployeePermission,
  Ll as setEmployeePermission,
  Tl as setOrderMutationPolicy,
  Pl as setOrderPolicy,
  uc as setOwnerPointWarehouse,
  oc as setOwnerProductPublication,
  us as setProductPublication,
  ds as setProductSlug,
  ao as updateCartLine,
  Is as updateDistributorStatus,
  ko as updateDistributorUser,
  Mi as updateTerritory,
  Jo as updateTradepointWarehouse,
  ss as uploadCategoryPhoto,
  po as uploadDistributorLogo,
  is as uploadProductPhoto
};
//# sourceMappingURL=index.js.map
